/**
 * @license
 * @qwik.dev/core 2.0.0-beta.37-dev+51dba9f
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as ve, isBrowser as _e } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as be } from "@qwik.dev/core/preloader";

const ge = !1;

const Se = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const ke = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Re = (t, n, e, s, o = !1) => {
    const r = ke(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Pe = (t, n, e) => {
    const s = ke(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Te = (t, n, e) => ke(t, n, e) >= 0;

const qe = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Me = t => typeof t === "object" && t !== null;

const xe = t => Array.isArray(t);

const Ae = t => typeof t === "string";

const Ie = t => typeof t === "function";

const Ne = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Se(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ce = "<sync>";

const Oe = t => typeof t === "function" && typeof t.getSymbol === "function";

const Xh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const je = "q:type";

const Le = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const De = 124;

const Ve = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const We = "q:renderFn";

const Ue = "q:targetEl";

const ze = "⚡️";

const Be = "q:slot";

const Qe = "q:s";

const He = "[q\\:patch]";

const Dh = "q:r";

const Wh = "q:rp";

const Je = "q:style";

const Ye = "style[q\\:style]";

const Ge = Ye + ",style[q\\:sstyle]";

const Ke = "q:sstyle";

const Ze = "q:ctx";

const ts = "q:brefs";

const ns = (t, n) => t["qFuncs_" + n] || [];

const es = "q:base";

const ss = "q:container-island";

const rs = "/" + ss;

const is = "q:ignore";

const os = "/" + is;

const ls = "q:container";

const us = "/" + ls;

const cs = "q:cursorBoundary";

const fs = "q:template";

const as = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const hs = "http://www.w3.org/1999/xhtml";

const ds = "http://www.w3.org/2000/svg";

const ps = "http://www.w3.org/1998/Math/MathML";

const $s = "qRender";

const ys = "q:id";

const ms = "q:key";

const ws = "q:props";

const bs = "q:seq";

const vs = "q:seqIdx";

const _s = "q:p";

const gs = "q:ps";

const Ss = ":on";

const ks = ":onIdx";

const Rs = ":onFlags";

const Ps = ":nearestCursorBoundary";

const Ts = ":";

const qs = "dangerouslySetInnerHTML";

const xs = 100;

const As = t => !!t && typeof t == "object" && typeof t.then === "function";

const Is = (t, n, e) => {
    try {
        const s = t();
        return As(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Ns = (t, n) => As(t) ? t.then(n) : n(t);

const Cs = t => new Promise(n => {
    setTimeout(n, t);
});

const Os = t => {
    throw t;
};

function n(t, n = Os) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!As(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = xs;
    const r = async e => {
        for (;As(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!As(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const js = t => ze + t;

const Ls = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + js(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Fs = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Xs(t.slice(s, -1));
        }
    }
    return null;
}

const Xs = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Ds(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Ds = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Vs = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const Ws = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Us = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const zs = t => {
    if (!t) {
        return "";
    }
    if (Ae(t)) {
        return t.trim();
    }
    const n = [];
    if (xe(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = zs(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Bs = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Qs = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (xe(t)) {
            throw Ne(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Bs(e) + ":" + Hs(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function s(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = zs(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Qs(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Hs = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Ws.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Js = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Ys = () => ({
    isServer: ve,
    importSymbol(t, n, e) {
        if (ve) {
            const t = Xh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ne(6, [ e ]);
        }
        if (!n) {
            throw Ne(14, [ e ]);
        }
        if (!t) {
            throw Ne(13, [ n, e ]);
        }
        const s = Gs(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Gs = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(es) ?? s, s);
    return new URL(e, o);
};

let Ks = /*#__PURE__ */ Ys();

const Zs = t => Ks = t;

const tr = () => Ks;

const Vh = () => Ks.isServer;

const Uh = typeof document !== "undefined";

const nr = !ve && Uh;

const er = nr ? document : void 0;

const sr = nr && er.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const rr = /\.[mc]?js$/;

const ir = 1e3 / 60;

const or = t => {
    let n = lr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Vt: t,
            Ot: rr.test(t) ? 0 : 3,
            Wt: n,
            Ut: 1,
            zt: performance.now(),
            Bt: 0,
            Qt: 0
        }))(t, e);
        lr.set(t, n);
    }
    return n;
};

const lr = new Map;

let ur = 0;

const cr = [];

const fr = Js(function zh() {
    hr = !1;
    if (!cr.length) {
        return;
    }
    const t = performance.now() + ir;
    let n = !1;
    for (;cr.length; ) {
        const e = cr[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || ur < 25)) {
            break;
        }
        cr.shift();
        mr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && cr.length && !hr) {
        hr = !0;
        fr();
    }
});

const ar = Js(r);

let hr = !1;

let dr = !1;

let pr = !1;

const $r = [];

const yr = () => {
    const t = $r[$r.length - 1];
    const n = t.Ht;
    if (t.Wt) {
        const e = t.Jt;
        if (e >= t.Wt.length) {
            $r.pop();
            return !1;
        }
        const s = t.Wt[e];
        t.Jt = e + 1;
        const o = or(s.Vt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Yt);
        } else {
            const t = 1 - s.Yt * r;
            const n = s.Gt;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Gt = e;
        }
        $r.push({
            Ht: o,
            Ut: i,
            Kt: t.Kt
        });
        return !0;
    }
    if (t.Kt?.has(n)) {
        $r.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        $r.pop();
        return !1;
    }
    if (n.Wt?.length) {
        const e = t.Kt || new Set;
        e.add(n);
        t.Kt = e;
        t.Wt = n.Wt;
        t.Jt = 0;
        return !1;
    }
    $r.pop();
    return !1;
};

function r() {
    if (pr || !$r.length) {
        return;
    }
    dr = !1;
    pr = !0;
    const t = nr ? performance.now() + ir : 0;
    let n = !1;
    for (;$r.length; ) {
        n = !0;
        const e = yr();
        if (nr && e && performance.now() >= t) {
            if (!dr) {
                dr = !0;
                ar();
            }
            break;
        }
    }
    pr = !1;
    n && nr && fr();
}

const mr = t => {
    if (t.Ot >= 2) {
        return;
    }
    ur++;
    const n = performance.now();
    t.Bt = n - t.zt;
    t.Ot = 2;
    const e = er.createElement("link");
    e.href = new URL("undefined" + t.Vt, er.baseURI).toString();
    e.rel = sr;
    e.as = "script";
    e.onload = e.onerror = () => {
        ur--;
        const s = performance.now();
        t.Qt = s - n;
        t.Ot = 4;
        e.remove();
        fr();
    };
    er.head.appendChild(e);
};

const wr = (t, n) => {
    const e = or(t);
    e && ((t, n) => {
        $r.unshift({
            Ht: t,
            Ut: n,
            Kt: void 0
        });
    })(e, n);
};

nr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    wr(e, 0);
                }
            } else {
                wr(t, 0);
            }
            nr ? ar() : r();
        })(t);
    }
});

const br = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const vr = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const _r = '"';

const gr = "[";

const Er = "]";

const Sr = ",";

const kr = "2.0.0-beta.37-dev+51dba9f";

const Rr = t => t.nodeType === 1;

const Bh = t => t.Cn;

const Pr = Symbol();

class Tr {
    [Pr]=void 0;
}

const qr = t => t === "foreignObject";

const Mr = t => t === "svg" || qr(t);

const xr = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Ts && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const Ar = {
    elementNamespace: hs,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!xl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && qr(xl(t));
    let o = hs;
    let r = 0;
    const i = typeof n === "string" || Zo(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Mr(t);
        }
        if (Zo(t)) {
            return Mr(xl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = ds;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return xr(t);
        }
        if (Zo(t)) {
            return xr(xl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = ps;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? ds : e ? ps : hs;
        r = t.flags & 1536;
    }
    Ar.elementNamespace = o;
    Ar.elementNamespaceFlag = r;
    return Ar;
}

class Ir {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Pr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Nr extends Ir {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Cr extends Nr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Or extends Ir {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const jr = [];

const Lr = [];

function l(t, n) {
    const e = y(n).priority;
    let s = jr.length;
    for (let t = 0; t < jr.length; t++) {
        const n = y(jr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    jr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < jr.length; t++) {
        const n = jr[t];
        let e = !1;
        for (let t = 0; t < Lr.length; t++) {
            const s = Lr[t];
            if (Zl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    Lr.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = jr.indexOf(t);
    if (s !== -1) {
        jr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = Lr.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Lr.length - 1;
    e !== s && (Lr[e] = Lr[s]);
    Lr.pop();
    n.o--;
    return !0;
}

const Fr = new WeakMap;

const Xr = ":nodeProps";

const Dr = ":nodeDiff";

const Vr = ":errorData";

const Wr = ":signal";

const Ur = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return Fr.get(t) ?? null;
}

const zr = Symbol();

class Br {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Qr = Symbol();

const Hr = Symbol();

const Jr = Symbol();

function m(t, n, e) {
    t[Pr] || (ve && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(ts, new Map) : t[Pr] = new Map);
    const o = t[Pr];
    let r = o.get(n);
    if (!r) {
        r = new Br(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Yr = (t, n) => (e, s) => {
    const o = me();
    o.Ft = m(t, ":");
    o.$ = n || void 0;
    return pe(o, () => {
        if (Ie(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (du(e)) {
            return e.value;
        }
        if (Me(e) && qu(e)) {
            In(ku(e), Jr, Su(e), o.Ft);
            return e;
        }
        throw Ne(2);
    });
};

class Gr {
    Zt;
    ct=void 0;
    $=null;
    tn=null;
    constructor(t, n) {
        this.$ = t || $f()?.$ || null;
        this.Zt = n;
    }
    trigger() {
        wu(this.$, this, this.ct);
    }
    force() {
        wu(this.$, this, this.ct);
    }
    get untrackedValue() {
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = $f();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ft;
        if (e) {
            const t = ve;
            const s = this.ct ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            pu(s, e);
            $u(e, this);
            if (t) {
                const t = mu(n.$, this.$);
                o && t?.nn?.(this, e, null);
                yu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Zt) {
            this.Zt = t;
            wu(this.$, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Zt
        };
    }
}

class Kr extends Gr {
    en;
    h;
    [Pr]=void 0;
    constructor(t, n, e = 17) {
        super(t || $f()?.$, zr);
        this.en = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = me();
        t.$ = this.$ || void 0;
        const e = n($e.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.en;
        hu(t);
        const n = $f();
        const e = n?.Ft;
        if (n) {
            const t = m(this, ".");
            Rn(this.$, t);
            n.Ft = t;
        }
        try {
            const e = t.getFn(n)();
            if (As(e)) {
                throw Ne(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ft = e);
        }
    }
}

class Zr {
    sn;
    rn=null;
    ln=!1;
    un=!0;
    constructor(t, n, e) {
        this.sn = t;
        if (n !== void 0) {
            this.info = n;
            this.cn = e;
        }
    }
    get track() {
        return this.fn ||= Yr(this.sn, this.sn.$);
    }
    get abortSignal() {
        return (this.an ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.sn.Zt;
        if (t !== zr) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.hn ||= []).push(t);
    }
}

class ti extends Kr {
    dn=!1;
    pn=void 0;
    $n=null;
    [Pr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Zt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.yn = r;
            this.mn = [];
        }
        const i = s.timeout;
        i && (this.wn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.$n?.rn) {
            if (this.Zt === zr || ve) {
                throw this.$n?.rn;
            }
            return this.Zt;
        }
        if (this.pn) {
            throw this.pn;
        }
        if (ve && this.h & 64 && this.Zt === zr) {
            throw Ne(35);
        }
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.bn = void 0;
        if (this.mn) {
            for (let t = 0; t < this.mn.length; t++) {
                this.mn[t].un = !1;
            }
        } else {
            this.$n && (this.$n.un = !1);
        }
        this.vn();
        super.value = t;
        this._n();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = $f();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                pu(this.$t ||= new Set, t);
                $u(t, this);
                yu(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.dn) {
            this.dn = t;
            wu(this.$, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if (ve && this.$n?.rn) {
            throw this.$n?.rn;
        }
        return this.dn;
    }
    get error() {
        const t = this.untrackedError;
        const n = $f();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                pu(this.yt ||= new Set, t);
                $u(t, this);
                yu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.pn) {
            this.pn = t;
            wu(this.$, this, this.yt);
        }
    }
    get untrackedError() {
        return this.pn;
    }
    get expires() {
        return this.Pt || 0;
    }
    set expires(t) {
        this.vn();
        this.Pt = t;
        this.Pt && this.gn() && this._n();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Pt && this.gn()) {
            this.vn();
            this._n();
        }
    }
    get interval() {
        const t = this.Pt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.bn = t;
            this.cn = this.cn === void 0 ? 1 : this.cn + 1;
        }
        this.En(!0, this.h & 128);
    }
    En(t, n) {
        this.h |= 1;
        this.vn();
        n && (this.Zt = zr);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.$n && this.Sn(this.$n, t);
    }
    wt() {
        if (!(this.h & 32) || this.gn()) {
            return;
        }
        if (!_e) {
            return;
        }
        setTimeout(() => {
            this.gn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.$n?.rn; ) {
            await (this.$n?.rn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (ve && this.h & 64) {
            this.dn = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.vn();
        this.h &= -2;
        const t = this.$n;
        t && this.Sn(t);
        const n = this.yn === 0 ? Infinity : this.yn ?? 1;
        if (this.mn ? this.mn.length >= n : t?.rn) {
            this.h |= 1;
            return;
        }
        const e = this.cn;
        const s = new Zr(this, this.bn, e);
        this.$n = s;
        this.mn && this.mn.push(s);
        s.rn = this.kn(s);
    }
    async kn(t) {
        let e = this.en.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.en.resolve();
            if (t.an?.signal.aborted) {
                t.rn = null;
                return;
            }
        }
        try {
            this.wn && (this.Rn = setTimeout(() => {
                const n = Error(`timeout ${this.wn}ms`);
                this.Pn(t, n);
                t.an?.abort(n);
            }, this.wn));
            const s = n(e.bind(null, t));
            let o;
            if (As(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.rn = null;
            if (t.un) {
                const n = this.mn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].un = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.rn = null;
            this.Pn(t, n);
        }
        if ((() => t === this.$n)()) {
            clearTimeout(this.Rn);
            t.cn === this.cn && (this.bn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this._n();
            }
        }
    }
    Pn(t, n) {
        if (t !== this.$n || !t.un) {
            return;
        }
        t.un = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = zr;
    }
    async Tn() {
        this.vn();
        clearTimeout(this.Rn);
        const t = this.$n;
        t && this.Sn(t);
        this.mn ? await Promise.all(this.mn.map(t => t.rn)) : await (t?.rn);
    }
    vn() {
        if (this.qn !== void 0) {
            clearTimeout(this.qn);
            this.qn = void 0;
        }
    }
    _n() {
        if (ve || !this.Pt) {
            return;
        }
        this.vn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.qn = setTimeout(() => this.En(t, n), this.Pt);
        this.qn?.unref?.();
    }
    gn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    Sn(t, n) {
        if (t.ln) {
            return;
        }
        t.ln = !0;
        t.an?.abort(n);
        t.rn = Ns(t.rn, () => this.Mn(t));
    }
    Mn(t) {
        const n = t.hn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.rn = null;
            n && (n.length = 0);
            const e = this.mn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    As(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const ni = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const ei = Symbol();

const si = Symbol();

const ri = Symbol();

const ii = Symbol();

const oi = Symbol();

const li = Symbol();

const ui = [];

const ci = {};

Object.freeze(ui);

Object.freeze(ci);

function w(t) {
    return new Proxy({}, new fi(t));
}

class fi {
    owner;
    ct=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ei) {
            return this.owner.constProps;
        }
        if (n === si) {
            return this.owner.varProps;
        }
        if (n === ri) {
            return this.owner;
        }
        if (n === ii) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = di(this.owner, n);
            n in this.owner.varProps && ai(this, n);
        }
        return s instanceof Ii ? s.value : s;
    }
    set(t, n, s) {
        if (n === ri) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ei) {
            this.owner.constProps = s;
        } else if (n === si) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ci ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                hi(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && hi(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ei || n === si) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && ai(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ai = (t, n) => {
    const e = $f();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ft;
    s && In(t.owner._proxy, n, t, s);
};

const hi = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && wu(t.$, t, e);
    return !!e;
};

const di = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const pi = (t, n) => $i(t)?.[n] || yi(t)?.[n] || null;

const $i = t => {
    if (!t) {
        return null;
    }
    return si in t ? "children" in t ? {
        ...t[si],
        children: t.children
    } : t[si] : t;
};

const yi = t => {
    if (!t) {
        return null;
    }
    return ei in t ? t[ei] : null;
};

const mi = t => t && si in t;

const wi = t => (n, ...e) => t.call(null, Yf(n), ...e);

class bi extends Kr {
    constructor(t, n) {
        super(t, n, 17);
    }
    xn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        hu(this.en);
        const t = bf(this.en.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Zt === zr ? e : this.Zt;
        const r = _f(() => this.xn ? s?.(o) || o : n(o), this, ".", this.$);
        this.xn = !0;
        this.h &= -2;
        const i = this.xn && r !== "undefined" || r !== this.Zt;
        if (i) {
            this.Zt = r;
            wu(this.$, this, this.ct);
        }
    }
}

const vi = (t, n) => new Kr(n?.container || null, t, vu(n?.serializationStrategy || "always"));

const _i = (t, n) => new ti(n?.container || null, t, vu(n?.serializationStrategy || "always"), n);

const gi = t => new bi(null, t);

const Ei = t => new Gr(null, t);

const Si = /*#__PURE__*/ wi(vi);

const ki = /*#__PURE__*/ wi(_i);

const Ri = wi(gi);

const Pi = t => t.value;

const Ti = (t, n) => t[n];

const qi = t => {
    if (t.length === 1) {
        if (du(t[0])) {
            return t[0].tn ||= new Ii(null, Pi, t, null);
        }
        if (qu(t[0])) {
            return new Ii(null, Pi, t, null);
        }
        return t[0].value;
    }
    return new Ii(null, Ti, t, null);
};

const Mi = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Me(n)) {
        return n[e];
    }
    if (du(n)) {
        if (n instanceof Ii) {
            return n;
        }
        return qi(t);
    }
    if (mi(n)) {
        const s = n[ei];
        const o = n[si];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return xi(n, t);
        }
    } else {
        const s = ku(n);
        if (s) {
            const n = s[e];
            return xi(n, t);
        }
    }
    return n[e];
};

const xi = (t, n) => du(t) ? t : qi(n);

const Ai = (t, n) => {
    const e = Mi(t, n);
    if (e === oi) {
        return t[n];
    }
    return e;
};

class Ii extends Gr {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [Pr]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, zr);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, Wr, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            wu(this.$, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = _f(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Zt;
        if (n) {
            this.h |= 2;
            this.Zt = t;
        }
    }
    rt() {
        return this.ot === Pi && du(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw Ne(31);
    }
    get value() {
        return super.value;
    }
}

class Ni {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Ci {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || br(n) ? ci : n;
        this.constProps = !e || br(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const Oi = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const ji = t => t instanceof Ci;

const Li = (t, n) => {
    if (typeof t === "string") {
        const e = ue(n);
        jf(Lf(e, t));
    }
    return null;
};

function b(t, n) {
    Li(this, n);
    const e = Of[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    Li(this, n);
    const e = Of[0];
    e.value = n.checked;
}

function _(t, n) {
    Li(this, n);
    if (Of) {
        for (let t = 0; t < Of.length; t++) {
            const n = Of[t];
            n instanceof ti && n.h & 64 && n.p();
        }
    }
}

const Fi = "bind:value";

const Xi = "bind:checked";

const Di = "passive:";

const Vi = "preventdefault:";

const Wi = Object.prototype.hasOwnProperty;

const Ui = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Xs(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const zi = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Xs(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Xs(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Xs(t.slice(11, -1));
    }
    return null;
};

const Bi = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = zi(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Qi = (t, n, e, s, o, r, i) => new Ci(t, n, e, s, o, r, !1, i);

const Hi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Di)) {
                    r.push(o);
                    t.add(Xs(o.slice(8)));
                } else {
                    o.startsWith(Vi) ? h.push(o) : zi(o) !== null ? s.push(o) : o === Xi ? a = e[o] : o === Fi && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Di)) {
                    i.push(s);
                    t.add(Xs(s.slice(8)));
                } else {
                    s.startsWith(Vi) ? d.push(s) : zi(s) !== null ? o.push(s) : s === Xi ? a = n[s] : s === Fi && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Ui(e, r, h, t, l);
            l = l || e !== n;
            e = Bi(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Ui(n, i, d, t, u);
            u = u || n !== e;
            n = Bi(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Wi.call(n, Xi) && delete n[Xi];
                if (e && Wi.call(e, Xi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Xi];
                }
                n.checked = a;
                const t = Vf(null, "_chk", v, null, [ a ]);
                if (e && Wi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Oi(n, "q-e:input", t) || c;
                }
                c = Oi(n, "q-e:input", t) || c;
            } else if (f) {
                n && Wi.call(n, Fi) && delete n[Fi];
                if (e && Wi.call(e, Fi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Fi];
                }
                n.value = f;
                const t = Vf(null, "_val", b, null, [ f ]);
                if (e && Wi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Oi(n, "q-e:input", t) || c;
                }
                c = Oi(n, "q-e:input", t) || c;
            }
        }
        if (n && Wi.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Wi.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Ci(t, n, e, s, o, r, c || !0, i);
};

const Ji = (t, n, e, s) => Zi(t, n, s);

const Yi = (t, n, e, s, o) => Zi(t, {
    ...e,
    ...n
}, o);

const Gi = (t, n, e, s, o, r) => Zi(t, {
    ...e,
    ...n,
    children: s
}, r);

const Ki = t => t.children;

const Zi = (t, n, e, s, o) => Hi(t, n, null, null, 0, e, o);

const to = Zi;

const no = Zi;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Hi(t, n, null, s.children, 0, o);
}

const eo = t => t.children;

const so = (t, n) => new Ci(Ki, null, null, t.children, 0, n);

const ro = t => Qi(Ki, null, {
    [Qe]: ""
}, t.children, 0, t.name ?? "");

const io = Symbol();

const oo = () => null;

const lo = () => null;

const uo = t => t.children;

const co = (t, n) => Zi(so, {
    children: Zi(fo, t)
}, n);

const fo = () => null;

let ao = null;

let ho = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    ho || (ho = t.setAttributeNS);
                    ho.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            ao || (ao = t.setAttribute);
            ao.call(t, n, e);
        })(t, n, e);
    }
}

const po = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const $o = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ei];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[si];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new Ci(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && po.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Ii) {
            return gf(n, t, ":", e);
        }
    }
    return di(n, "name") || "";
}

class yo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class mo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class wo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class bo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class vo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const _o = t => new yo(t);

const go = t => new mo(t);

const Eo = (t, n) => new wo(t, n);

const So = (t, n, e) => new bo(t, n, e);

const ko = (t, n, e, s = null, o = !1) => new vo(t, n, e, s, o);

const Ro = () => {
    const t = mf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, bs);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, bs, s);
    }
    let o = t.$.getHostProp(e, vs);
    o === null && (o = 0);
    t.$.setHostProp(e, vs, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Po = t => {
    const n = Ie(t) && !ea(t) ? pe(void 0, t) : t;
    return Ei(n);
};

const To = t => qo(Po, t);

const qo = (t, ...n) => {
    const {val: e, set: s} = Ro();
    if (e != null) {
        return e;
    }
    t = Ie(t) && !ea(t) ? bf(t, ...n) : t;
    return s(t);
};

const Mo = () => ({
    pending: Ei(0),
    version: Ei(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, cs);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    ol(t, Ps, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return il(t, Ps, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && ol(t, Ps, n);
}

function x(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        x(t, o, P(t, o) || e);
    }
}

const xo = t => {
    if (t.Tn) {
        try {
            t.Tn();
        } catch (t) {
            ((t, ...n) => {
                Se(!1, t, ...n);
            })(t);
        }
        t.Tn = null;
    }
};

function A(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = wf(e, s));
    const r = o.$;
    const i = o.m;
    cl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = il(i, _s, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = il(i, gs, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return $e(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = wf(t, n);
    typeof this === "string" && jf(Lf(e.$, this));
    const s = Of[0];
    return A(s, t, n, e);
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Ao = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    ol(n, e, r);
    mn(t, ko(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        q: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Ni({
                O: s,
                et: !0
            }),
            st: new Ni({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.st.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Io = (t, n, e, s, o, r, i) => X(F(i, t, n, o, r), e, s);

const No = (t, n, e, s, o, r, i, c, l = !1, u) => X(F(u, t, n, i, c), e, s, o, r, l);

function X(t, n, e, s = Nl(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (As(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function D(t, n, e, s = Nl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.D = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (ji(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Ao.call(t.J.constProps, qs) || Ao.call(t.J.varProps, qs);
                            e ? t.D || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === eo) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === ro) {
                                nt(t);
                                J(t) || U(t, t.J.children, !0);
                            } else if (n === vt) {
                                H(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === lo) {
                                tt(t);
                            } else if (n === oo) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (du(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof Ii ? t.J.rt() : t.J;
                        const e = t.q?.[Pr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Ii && (s = At(e, n));
                        if (!s) {
                            const e = t.D || t.q;
                            U(t, V(t, () => gf(n, e, ".", t.$)), !0);
                        }
                    } else if (As(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.D || t.q);
                    }
                } else {
                    t.J === io || mt(t, "");
                }
                W(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function V(t, e) {
    try {
        return e();
    } catch (s) {
        if (As(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.q);
            return null;
        }
        throw s;
    }
}

function W(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.D !== null ? t.D = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && xe(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.Z || !!t.D || !Nl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.q;
        t.q = Nl(t.k);
        t.D = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    W(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.D, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Q(t) {
    if (t.D) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function H(t) {
    const n = t.J;
    const e = n.key;
    t.q = il(t.k, e, n => dl(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.D = Go();
        ol(t.D, Be, e);
        t.D.slotParent = t.k;
        ol(t.k, e, t.D);
    }
}

function J(t) {
    const n = t.J;
    const e = lu(t.k);
    const s = k(e, n, t.$);
    const o = di(n, cs) || null;
    const r = e ? il(e, s, null) : null;
    if (r == null) {
        t.D = Go();
        ol(t.D, Be, s);
        ol(t.D, cs, o);
        x(t.$, t.D, o);
        e && ol(e, s, t.D);
        Rl(t.M, t.k, t.D, Q(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.D = r;
        ol(t.D, Be, s);
        ol(t.D, cs, o);
        x(t.$, t.D, o);
        e && ol(e, s, t.D);
        kl(t.M, t.D);
        Rl(t.M, t.k, t.D, Q(t));
        n && Zo(n) && !n.firstChild && xl(n) === fs && ql(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            ql(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (As(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Nl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        Ml(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                ql(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && el(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        ql(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (du(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ne(15, [ e ]);
}

function st(t, e, s, o, r) {
    return n(() => gf(o, e, s, t, r));
}

function rt(t, n, e, o, r) {
    const i = t.O;
    const c = o.then(t => E(n, e, s(e, t, i), r));
    t.X.push(c);
}

function it(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(ls, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, r) {
    const i = function c(t, n) {
        const e = Tl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = Ho(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (Fs(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, r)) {
                continue;
            }
            du(o) && (o = st(t.$, t.D, n, o, t.tt.nt));
            if (As(o)) {
                rt(t, i, n, o, u);
                continue;
            }
            if (n === qs) {
                it(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            E(i, n, s(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = Ao.call(n.varProps, "class") || n.constProps && Ao.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    vl(t.M, t.k, t.D, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(A.bind(null, n));
                }
            } else {
                e && s.push(A.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = A.bind(null, n));
    }
    t.charAt(2) !== "e" && ll(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && Zo(t.q);
        const o = s && e === xl(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.q;
    s && function r(t, n, e, s) {
        t.Z || cl(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && Ao.call(o, r)) {
                const e = o[r];
                Pt(i, e) || Co(t, n, r, i, s);
            } else {
                i != null && Co(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                Ao.call(e, r) || r.charAt(0) === ":" || Fs(r) || Co(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Co = (t, n, e, s, o) => {
    if (Fs(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === _s || e === gs) {
        ol(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[Pr]?.get(e);
    if (du(s)) {
        const o = s instanceof Ii ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.tt.st);
    } else {
        i && Rn(t.$, i);
    }
    if (As(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = Zo(o) ? xl(o) : null;
                const r = wt(o) || bt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = Zo(i) ? xl(i) : null;
                const r = wt(i) || bt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = Zo(t.q) ? xl(t.q) : null;
                    const e = wt(t.q) || bt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = Zo(s) ? xl(s) : null;
                const e = wt(s) || bt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || Rl(t.M, o, t.D, C(t));
        t.q = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || bt(t.q, t.$._);
                if (n != null) {
                    const e = Zo(t.q) ? xl(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && Rl(t.M, o, n, C(t));
            t.q = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && sl(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        _l(t.M, t.k, t.D = Go(), Q(t));
        t.D.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        _l(t.M, t.k, t.D = Go(), Q(t));
        t.D.key = e;
    }
}

function pt(t, n) {
    const e = n[na];
    let s = t.D || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = bt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.q;
        }
        if (s) {
            const e = il(s, ws, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[ei], e[ei], e[ii], s, !1);
                        o ||= t;
                        const r = _t(n[si], e[si], e[ii], s, !0);
                        o ||= r;
                        e[ri] = n[ri];
                    } else if (n) {
                        ol(t, ws, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                ol(s, We, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Ci(vt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            Re(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (ji(n) && di(n, Be) || "") + "";
                const i = ke(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = bt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.D;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.D || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!sl(e) || il(e, We, null) === null); ) {
                e = e.parent || lu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Ur] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    _l(t.M, t.k, t.D = Go(), Q(t));
    const o = t.J;
    ol(t.D, We, e);
    ol(t.D, ws, s);
    t.D.key = o.key;
}

function yt(t) {
    _l(t.M, t.k, t.D = Go(), Q(t));
    const n = t.J;
    ol(t.D, ws, n.props);
    n.key && (t.D.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = iu(t.q);
        if (e === 3) {
            if (n !== Al(t.q)) {
                Il(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    vl(t.M, t.k, t.D = Yo(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || el(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || el(t)) {
        return null;
    }
    const e = il(t, We, n);
    return e ? e.it : null;
}

function vt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === ts) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = hi(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === ts) {
                continue;
            }
            if ((!t || !Ao.call(t, s)) && o) {
                delete n[s];
                const t = hi(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return br(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (el(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && il(o, We, null) !== null;
            if (r) {
                const e = t.getHostProp(o, bs);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Me(r)) {
                            const n = au(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Kr || r instanceof Ii) && (r.h & 4 || kn(t, r));
                            (n || r instanceof ti) && xo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? dl(t.rootVNode, e) : e;
                                let c = Nl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = rl(o);
            if (i) {
                if (o === e) {
                    const n = Nl(o);
                    if (n) {
                        vn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Nl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, Be);
    e != null && t.getHostProp(n.slotParent, e) === n && ol(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && xl(s) === fs) {
            St(t, e);
            ql(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Ii && n instanceof Ii && xt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (du(t) && du(n)) {
        const e = t instanceof Ii ? t.rt() : t;
        const s = n instanceof Ii ? n.rt() : n;
        return bf(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return Qs(t) === Qs(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return zs(t) === zs(n);
}

function xt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function At(t, n) {
    if (!(n instanceof Ii)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Ii && xt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Oo = (t, n, e, s, o) => {
    const r = ye(t.jt, n, t);
    if (e) {
        r.Ft = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, We));
    if (Oe(s)) {
        o = o || t.getHostProp(n, ws) || ci;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (ea(s)) {
        const t = s;
        i = () => $e(r, t, [ o || ci, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => $e(r, t, [ o || ci ]);
    }
    const l = ve;
    const u = (e = 0) => Is(() => {
        if (!c) {
            t.setHostProp(n, vs, null);
            t.setHostProp(n, ks, null);
        }
        e > 0 && Ko(n) && kn(t, n);
        return Ns(i(o), t => Ns(r.Xt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < xs) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Ss);
        if (o) {
            return function r(t, n, e) {
                const s = Ot(n);
                let o = n;
                const r = "q-e:qvisible";
                return Ns(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Lt();
                                    const n = ve;
                                    n && t.ut(i) || (o = jt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (As(t) && e < xs) {
            return t.then(() => u(++e));
        }
        if (e >= xs) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Vs(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ci && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (ji(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (xe(t)) {
            n.push(...t);
        } else {
            if (As(t)) {
                return Ns(t, t => Ot(t));
            }
            if (du(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (ji(t)) {
        if (t.type !== eo && !ea(t.type)) {
            return Qi(eo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : xe(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return Qi(eo, null, null, [ t, n ], 0, null);
    }
    if (xe(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Ci("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Xt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ft(t[c], c, r, s);
    }
    return i;
}

function Dt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Vt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Nl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return No(c, n, Xt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Ml(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return No(c, n, Xt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Ml(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            ql(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return No(c, n, Xt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            ql(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let I = m;
    const x = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                I = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || Rl(n, e, t, I);
                I = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = No(c, n, Xt(o, a, null, i, l, M), e, I, I, s, null, !0, f);
            return Ns(d, () => {
                const t = Dt(e, I, u);
                I = t;
                M = l - 1;
                return x();
            });
        }
    };
    return x();
}

function Wt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, bs);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof fu) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = cu(s, n, t);
                As(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[Dr] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Vr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Vr] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = wl(n, document, r, e);
    const u = Zo(r) && i || r;
    const f = u === r ? null : c;
    vl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Dr];
    }(t);
    if (!r) {
        return;
    }
    Ut(t, null);
    du(r) && (r = r.value);
    return Io(n, e, r, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, We);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, ws) || null;
    return Jt(n, o, o, r, i, e, s);
}

function Ht(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Ur] || null;
        e && delete n[Ur];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Jt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Jt(t, e, s, o, r, i, c) {
    const l = Is(() => Oo(t, e, s, o, r), s => {
        const o = t.getHostProp(e, Ke);
        return n(() => Io(t, i, s, e, c, Ls(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (As(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(ko(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Xr] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        du(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Xr];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, bs);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof fu && n.h & 16) {
            n.h &= -17;
            const t = n;
            xo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, Wr);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = me();
    r.$ = e;
    return Ns(n(() => pe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return wu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, ws) || null;
    if (!r) {
        return;
    }
    let i = pi(r, "items");
    du(i) && (i = bf(i));
    const c = pi(r, "key$");
    const l = pi(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Vt(n, e, o, s, i, u, f);
    }
    return Ns(c.resolve(), t => Ns(l.resolve(), r => Vt(n, e, o, s, i, t, r)));
}

let jo = null;

const Lo = (t, n, e) => {
    jo || (jo = t.insertBefore);
    jo.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let o = null;
    const r = new Set;
    const i = () => {
        if (o) {
            if (o.length === 1) {
                Lo(n, o[0], e);
            } else {
                const t = n.ownerDocument || n;
                const s = t.createDocumentFragment();
                for (let t = 0; t < o.length; t++) {
                    s.appendChild(o[t]);
                }
                Lo(n, s, e);
            }
            o = null;
            n = null;
            e = null;
            r.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof bo) {
            if (n === l.parent && e === l.beforeTarget) {
                o || (o = []);
                o.push(l.target);
                r.add(l.target);
                continue;
            }
            if (!o) {
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (r.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            Lo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof yo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof mo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof wo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof vo) {
            const t = l.target;
            const e = l.attrName;
            const o = l.attrValue;
            const r = o != null ? s(e, o, l.scopedStyleIdPrefix) : null;
            const c = r == null || r === !1;
            if (Fo(t, e)) {
                t[e] = Xo(r);
            } else if (e === qs) {
                n === t && i();
                t.innerHTML = r;
                t.setAttribute(ls, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = r : E(t, e, r, l.isSvg);
            }
        }
    }
    i();
}

const Fo = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Xo = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Do = (t => () => queueMicrotask(t))(rn);

const Wo = Js(rn);

let Uo = !1;

function en() {
    if (!Uo) {
        Uo = !0;
        Do();
    }
}

function sn() {
    if (!Uo) {
        Uo = !0;
        Wo();
    }
}

function rn() {
    Uo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            sn();
            return;
        }
    }
}

function on(t, n) {
    const e = ve;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Wt(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && As(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    cu(s, t, s.ft);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.ht();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(cs in n.props) || !t.getHostProp(n, cs)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Fr.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Xr);
            if (!e || e.size === 0) {
                return;
            }
            for (const [o, r] of e.entries()) {
                let e = r.value;
                du(e) && (e = e.value);
                const i = s(o, e, r.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, o, i);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(bs);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof fu) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = cu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        As(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, ws) || null;
            if (!s) {
                return;
            }
            let o = pi(s, "items");
            du(o) && (o = bf(o));
            const r = await pi(s, "key$").resolve();
            const i = await pi(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const zo = [];

function $n(t) {
    for (let n = 0; n < zo.length; n++) {
        const e = zo[n];
        const s = zo[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return ve;
    }()) {
        const e = pn(t, n);
        As(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            zo.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = dn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    $n(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    zo.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                zo.push(r);
                r = r.slotParent || r.parent;
            }
            zo.length = 0;
            ((t, ...n) => {
                const e = Se(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? M(n, P(t, n)) : function l(t, n) {
            zo.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    M(n, e);
                    $n(s);
                    zo.length = 0;
                    return !0;
                }
                zo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            zo.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const Bo = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Qo = t => {
    let n = null;
    return e => {
        n || (n = Bo(e, t));
        return n.call(e);
    };
};

const Ho = (t, n, e = null) => {
    const s = new Cr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Jo = t => {
    const n = new Cr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Yo = (t, n) => {
    const e = new Or(-4084, null, null, null, null, t, n);
    return e;
};

const Go = () => {
    const t = new Nr(null, -4094, null, null, null, null, null, null);
    return t;
};

const Ko = t => t instanceof Ir;

const Zo = t => (t.flags & 1) === 1;

const tl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const nl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const el = t => (t.flags & 4) === 4;

const sl = t => (t.flags & 2) === 2;

const rl = t => {
    const n = t.flags;
    return (n & 2) === 2 && il(t, Be, null) !== null;
};

const Qh = t => t;

const il = (t, n, e) => {
    if (Zo(t) || sl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const ol = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const ll = (t, n, e, s, o = null) => {
    if (Zo(n)) {
        ol(n, e, s);
        mn(t, ko(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const ul = t => {
    if (t.key) {
        return;
    }
    const n = Fl(t.node, Ts);
    n && (t.key = n);
};

const cl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Fs(c)) {
                wn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Ts && c) {
                if (c.startsWith(ls)) {
                    const t = i.value;
                    t === "html" ? ol(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && ol(e, "value", s.value);
                } else {
                    const t = i.value;
                    ol(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        il(e, _s, null) === null && il(e, gs, null) === null || (n.flags |= 64);
    }
};

const fl = t => {
    if (t.vt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Oe(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = fl(Ln(i[t], e));
        c.push(A.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function bn(t, n, e) {
    let s = Nl(n);
    for (;s; ) {
        if (el(s)) {
            hl(t, s);
            e(s, n);
        } else {
            Zo(s) ? e(s, n) : bn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function vn(t) {
    let n = t;
    if (el(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Nl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const al = (t, n, e) => {
    let s = t;
    for (;e && s && sl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !sl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !sl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (el(t) && e && Zo(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && nu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const hl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Pl(n, !0);
        const o = e.node;
        const r = Jl(s);
        let i = al(n, !1, !0);
        const c = al(n, !0, !0);
        const l = o || (c && Zo(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && el(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, So(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = al(i, !1, !0);
        }
        i = n;
        for (;i && el(i); ) {
            const n = al(i, !0, !0);
            const e = !n || !el(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Eo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, So(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const dl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = Jo(i);
            ul(e);
            t.vNode = e;
            return e;
        }
    }
    if (Ko(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || Jo(i);
            ul(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = yl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = ml(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = pl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const pl = (t, n) => {
    let e = Nl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const $l = [];

const yl = (t, n) => {
    let e = Nl(t);
    for (;e && (!(e instanceof Cr) || e.node !== n); ) {
        if (sl(e)) {
            const t = e.nextSibling;
            const n = Nl(e);
            if (n) {
                t && $l.push(t);
                e = n;
            } else {
                e = t || ($l.length ? $l.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || $l.pop();
        }
    }
    for (;$l.length; ) {
        $l.pop();
    }
    return e;
};

const ml = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const wl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Ho(o, "errored-host");
    if (tl(e)) {
        Rl(t, r, e, null);
    } else {
        const n = [];
        bn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Rl(t, r, n[e], null);
        }
    }
    return r;
};

const bl = nn;

const vl = (t, n, e, s) => {
    const o = Zo(n);
    o && Cl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Sl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Pl(n, !1);
    l && !c && mn(t, So(i, l, gl(t, n, s)?.node ?? null));
    El(n, e, s);
    c && (e.flags |= 32);
};

const _l = (t, n, e, s) => {
    const r = Zo(n);
    r && Cl(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    Sl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Ue] : null;
    const f = u ? null : r ? n : Tl(n, !1);
    const a = u || f?.node;
    const h = gl(t, n, s);
    const d = h?.node ?? null;
    const p = rl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = Tl(n, !1);
        const c = gl(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        bn(t, e, n => {
            if (el(n)) {
                mn(t, So(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Zo(c)) {
                                e = c.node;
                                const t = xl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Tl(l, !0);
                                if (h) {
                                    const t = o(h, xl(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Nl(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (jl(e)) {
                                    const t = ce(e);
                                    if (t) {
                                        const n = Nl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                mn(t, So(n.node, a, c));
            }
        });
    } else {
        a && !l && bn(t, e, n => {
            mn(t, So(n.node, a, d));
        });
    }
    El(n, e, s);
    l && (e.flags |= 32);
};

const gl = (t, n, e) => {
    let s = null;
    e == null ? sl(n) && (s = al(n, !0, !1)) : s = sl(e) ? al(e, !0, !0) : e;
    s && el(s) && hl(t, s);
    return s;
};

const El = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Sl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && ql(t, n, s, !1);
};

const kl = (t, n) => {
    let e = n;
    for (;e && sl(e); ) {
        e = e.lastChild;
    }
    e && el(e) && (e.flags & 8) === 0 && hl(t, e);
};

const Rl = (t, n, e, s) => {
    tl(e) ? vl(t, n, e, s) : _l(t, n, e, s);
};

const Pl = (t, n) => {
    for (;t && !Zo(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Ue];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Tl = (t, n) => {
    for (;t && !Zo(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const ql = (t, n, e, s) => {
    el(e) && hl(t, e);
    if (s) {
        const s = il(n, qs, null) !== null;
        if (s) {
            return;
        }
        tl(e) ? mn(t, _o(e.node)) : bn(t, e, n => {
            mn(t, _o(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Ml = (t, n, e, s = !0) => {
    const o = Pl(n, !0);
    if (o && s) {
        if (tl(n)) {
            mn(t, go(n.node));
        } else {
            const e = Tl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, go(o)) : bn(t, n, n => {
                mn(t, _o(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const xl = t => {
    const n = Qh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Hl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Ql(t);
            switch (n) {
              case ds:
                return 512;

              case ps:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Al = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Il = (t, n, e) => {
    hl(t, n);
    n.text = e;
    mn(t, Eo(n.node, e));
};

const Nl = t => {
    if (el(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Zo(t) && function e(t) {
        const n = t.getAttribute(Wh);
        if (n === null) {
            return !1;
        }
        const e = Bl(t);
        return ou(e) && e.localName === "template" && e.getAttribute(Dh) === n && Wl(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Cl(t));
    return n;
};

const Cl = n => {
    const e = Qh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && jl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Bl(e);
            const o = Jl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                ul(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === De && o.charCodeAt(1) === De) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Yl(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = ou(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        Gl(e, ($, y, m, w, b) => {
                            if (eu($())) {
                                for (;d(o); ) {
                                    o = Wl(o);
                                    if (!o) {
                                        throw Ne(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;eu($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = Jo(o);
                                    ul(n);
                                    u(n);
                                    o = Wl(o);
                                    for (;ou(o) && Sn(o); ) {
                                        o = Wl(o);
                                        if (!o && t > 0) {
                                            throw Ne(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                ol(n, Ke, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                ol(n, We, y());
                            } else if ($() === 61) {
                                h || (h = ue(s));
                                const t = y();
                                h.An(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                ol(n, ws, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === De;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                ol(n, bs, y());
                            } else if ($() === 94) {
                                ol(n, vs, y());
                            } else if ($() === 96) {
                                h || (h = ue(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = ue(s));
                                n.slotParent = dl(h.rootVNode, y());
                            } else if ($() === 93) {
                                ol(n, Ze, y());
                            } else if ($() === 123) {
                                m();
                                u(Go());
                                ru.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === De) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === De;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                ol(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = ru.pop();
                                l = ru.pop();
                                c = ru.pop();
                                i = ru.pop();
                                n = ru.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                ol(n, Be, e);
                            } else {
                                for (;ou(o) && Sn(o); ) {
                                    o = Wl(o);
                                }
                                const t = o && Xl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;su($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Or(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = ue(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Yl(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Ol = null;

const jl = t => {
    Ol || (Ol = t.hasAttribute);
    return Ol.call(t, ls);
};

let Ll = null;

const Fl = (t, n) => {
    Ll || (Ll = t.getAttribute);
    return Ll.call(t, n);
};

const Xl = Qo("nodeType");

const Dl = t => {
    const n = Xl(t);
    return n === 3 || n === 1;
};

let Vl = null;

const Wl = t => {
    Vl || (Vl = Bo(t, "nextSibling"));
    zl || (zl = Bo(t, "firstChild"));
    for (;t; ) {
        t = Vl.call(t);
        if (t !== null) {
            const n = Xl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(is)) {
                    return _n(t, ss, Vl, zl);
                }
                if (t.nodeValue?.startsWith(rs)) {
                    return _n(t, [ ss, os ], Vl, zl);
                }
                if (n?.startsWith(ls)) {
                    for (;t && (t = Vl.call(t)) && (Xl(t) !== 8 || !t.nodeValue?.startsWith(us)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = Ul(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const Ul = Qo("parentNode");

let zl = null;

const Bl = t => {
    zl || (zl = Bo(t, "firstChild"));
    t = t && zl.call(t);
    if (t && Xl(t) === 8) {
        Vl || (Vl = Bo(t, "nextSibling"));
        if (t.nodeValue?.startsWith(is)) {
            return _n(t, ss, Vl, zl);
        }
    }
    for (;t && !Dl(t); ) {
        t = Wl(t);
    }
    return t;
};

const Ql = Qo("namespaceURI");

const Hl = Qo("nodeName");

const Jl = Qo("ownerDocument");

const Yl = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;ou(i) && Sn(i); ) {
            i = Wl(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = Xl(i);
        let e = null;
        if (n === 3) {
            e = Yo(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = Jo(i);
            ul(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = Wl(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Gl(e, (e, s) => {
            if (e() === 61) {
                n || (n = ue(t.node));
                const e = s();
                n.An(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = ue(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Pr]) {
        const s = t[Pr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Pr, {
            get() {
                const s = e._(n);
                t[Pr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Pr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Gl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Kl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        cl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Ts) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Zl = (t, n) => {
    let e = tu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = tu(e);
    }
    return !1;
};

const tu = t => t.parent || t.slotParent;

const nu = t => {
    if (t === null || sl(t)) {
        return null;
    }
    return t.node;
};

function En(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Zo(e)) {
                        const t = fe(e.node);
                        if (!t) {
                            return null;
                        }
                        return ce(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (el(i)) {
            c.push(xn(Al(i)));
        } else if (sl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Kl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== je && e !== "__scopedStyleIdPrefix__") {
                        const t = il(i, e, null);
                        s.push(" " + e + "=" + xn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Le[il(i, je, null) || "V"] || Le.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Nl(i);
            u && c.push("  " + En.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Zo(i)) {
            const s = xl(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Kl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = il(i, n, null);
                l.push(" " + n + "=" + xn(e));
            }
            const f = nu(i);
            if (f) {
                const t = Jl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + xn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + xn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (nl(i) || e) {
                const e = Nl(i);
                e && c.push("  " + En.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const eu = t => 48 <= t && t <= 57;

const su = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(Ts) || t.nodeName === "STYLE" && (t.hasAttribute(Ke) || t.hasAttribute(Je));
}

const ru = [];

const iu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ne(26, [ n ]);
};

const ou = t => t && typeof t == "object" && Xl(t) === 1;

const lu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!sl(t) || il(t, We, null) === null); ) {
            const e = t.slotParent;
            const s = sl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    Ko(n) && Zo(n) && Cl(n);
    const e = n[Pr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ti) {
            Tn(s, n);
        } else if (s instanceof Gr) {
            Pn(t, s, n);
        } else if (mi(s)) {
            const t = s[ii];
            qn(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = Su(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof Ii && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function qn(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const uu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Ro();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new fu(6 | i, r, o.m, t, null);
    s(c);
    const l = o.$;
    const {Xt: u} = o;
    const f = Ns(u, () => cu(c, l, o.m));
    As(f) && (o.Xt = f);
};

const cu = (t, n, e) => {
    const s = t.In;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Ns(((t, n) => {
        const e = t.Nn;
        if (e) {
            return e;
        }
        const s = t.Tn;
        if (!s) {
            return;
        }
        t.Tn = null;
        try {
            const e = s();
            if (As(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Nn === s && (t.Nn = void 0);
                });
                t.Nn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = me(n.jt, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => kn(n, t));
        const c = Yr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Tn = () => {
                            t.Tn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    As(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Is(() => i(u), l, s => {
            if (As(s)) {
                return s.then(() => {
                    t.In === r && (t.In = null);
                    return cu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (As(i)) {
        r = i.finally(() => {
            t.In === r && (t.In = null);
        });
        t.In = r;
        return r;
    }
    return i;
};

class fu extends Tr {
    h;
    Jt;
    ft;
    bt;
    Tn;
    Nn;
    In=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Jt = n;
        this.ft = e;
        this.bt = s;
        this.Tn = o;
    }
}

const au = t => t instanceof fu;

function Mn(t, n) {
    const e = ue(n);
    typeof this === "string" && jf(Lf(e, this));
    const s = Of[0];
    s.h |= 4;
    yn(e, s.ft, 1);
}

const hu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const du = t => t instanceof Gr;

const pu = (t, n) => {
    t.add(n);
};

const $u = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const yu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        au(e) ? o = e.bt : e instanceof Kr ? o = e.en : s === ":" && (o = n.getHostProp(e, We));
        o && n.serializationCtx.At.add(o);
    }
};

const mu = (t, n) => {
    if (t && (!n || t === n || Bh(t))) {
        return t;
    }
    return n;
};

const wu = (t, n, e) => {
    const s = _e;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (au(o)) {
                o.h |= 4;
                yn(t, o.ft, 1);
            } else if (o instanceof Gr) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ni) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Xr];
                            if (!o) {
                                o = new Map;
                                s[Xr] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Xr);
                        if (!n) {
                            n = new Map;
                            t.setProp(Xr, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const bu = t => Me(t) && typeof t[Jc] === "function";

const vu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const _u = t => {
    t.h |= 4;
};

const gu = [];

function xn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (au(t)) {
            return `Task(${xn(t.bt)})`;
        }
        if (Oe(t)) {
            return `Qrl(${t.vt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (gu.includes(t)) {
                return "*";
            }
            gu.length;
            try {
                gu.push(t);
                if (Array.isArray(t)) {
                    return Ko(t) ? "(" + (il(t, je, null) || "vnode") + ")" : t.map(xn);
                }
                if (du(t)) {
                    return t instanceof Ii ? "WrappedSignal" : t instanceof Kr ? "ComputedSignal" : "Signal";
                }
                if (qu(t)) {
                    return "Store";
                }
                if (ji(t)) {
                    return Eu(t);
                }
                if (Ko(t)) {
                    return "(" + (il(t, je, null) || "vnode") + ")";
                }
            } finally {
                gu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Eu = t => {
    if (ji(t)) {
        if (typeof t.type === "function") {
            const n = t.type[na];
            if (n) {
                const [t] = n;
                return "Component(" + t.vt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + xn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Eu(e);
                    }
                } else {
                    n += Eu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Su = t => t[Hr];

const ku = t => t?.[Qr] || null;

const Ru = (t, n) => {
    const e = Su(t);
    e && e.force(n);
};

const Pu = (t, n) => {
    const e = Su(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Tu = t => ku(t) || t;

const qu = t => Qr in t;

function An(t, n, e) {
    return new Proxy(n, new xu(e, t || null));
}

const Mu = (t, n, e) => {
    if (qe(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = An(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class xu {
    h;
    $;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = ku(this);
        wu(this.$, this, Cn(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Qr) {
                return t;
            }
            if (n === Hr) {
                return this;
            }
            return t[n];
        }
        const e = $f();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ft;
            o && In(t, Array.isArray(t) ? Jr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Me(s) && !Object.isFrozen(s) && !qu(s) && !Object.isFrozen(t)) {
            return Mu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Tu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || wu(this.$, this, Cn(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === Qr) {
            return !0;
        }
        if (typeof n === "string") {
            const e = $f();
            if (e) {
                const s = e.Ft;
                s && In(t, Array.isArray(t) ? Jr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = $f();
        const e = n?.Ft;
        e && In(t, Jr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const r = e.ct ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = ve;
    const l = __EXPERIMENTAL__.suspense && e instanceof xu && c;
    pu(i, s);
    $u(s, t);
    if (c) {
        const i = mu(o, e.$);
        l && i?.nn?.(t, s, n, r);
        yu(s, i);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ct);
    o && wu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Jr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Au = Symbol();

const Iu = [ void 0, null, !0, !1, "", ui, ci, zr, Jr, li, ro, eo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Nu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Cu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n.vt;
    let o = n._t;
    const r = tr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Oe(t) && t.vt == Ce)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.Et(n.it));
        if (!o) {
            throw Ne(14, [ n.vt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.St(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return Vf(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, r, i, n);
}

class Ou {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class ju {
    On;
    jn=0;
    Rt=[];
    Ln=0;
    Fn=new Set;
    Xn=new Map;
    Dn;
    Vn=new Map;
    Wn=0;
    Nt;
    Un=typeof Temporal !== "undefined";
    constructor(t) {
        this.On = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        const t = this.Wn;
        this.Wn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Wn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Wn;
        this.Wn = s;
        this.Nt.write(gr);
        this.On.zn = 0;
        try {
            this.Nt.write(t + "");
            this.Nt.write(Sr);
            this.Nt.write(gr);
            await this.outputSelectedRoots(n);
            this.Nt.write(Er);
            const s = this.getForwardRefsPayload();
            this.On.zn = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Nt.write(Sr);
                s ? this.outputForwardRefsArray(s) : this.Nt.write("0");
            }
            if (e !== void 0) {
                this.Nt.write(Sr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Nt.write(_r);
                    this.writeRootRefPath(e);
                    this.Nt.write(_r);
                }
            }
        } finally {
            this.Wn = o;
        }
        this.Nt.write(Er);
    }
    Bn(t) {
        this.Nt = t;
    }
    outputArray(t, n, e) {
        this.Nt.write(gr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(Sr) : s = !0;
            e(t[n], n);
        }
        this.Nt.write(Er);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : _r + t + _r;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Nt.write(n.slice(s, e));
            this.Nt.write("<\\/");
            s = e + 2;
        }
        this.Nt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Nt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Nt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Nt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Nt.write(_r);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Nt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Nt.write(_r);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Nt.write(t + Sr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Nt.write(_r);
                this.writeRootRefPath(n);
                this.Nt.write(_r);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Nt.write(t + Sr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Nt.write(t + Sr + n);
        } else if (typeof n === "string") {
            this.Nt.write(t + Sr);
            this.outputString(n);
        } else {
            this.Nt.write(t + Sr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.On.getSeenRef(t);
        const o = !e && this.Xn.get(t);
        if (s) {
            s.Dn && this.isSeenInStreamedRoot(s) && (s = this.On.Qn(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.On.Hn(t, this.Dn, n);
            }
            s = this.On.St(t, !0);
        }
        if (s.Dn) {
            if (this.Dn) {
                this.On.Jn(s, t);
            } else {
                this.On.Jn(s, t, n);
                t = this.On.Yn[n];
            }
        }
        if (typeof o === "number") {
            this.Rt[o] = s.Jt;
            this.Xn.delete(t);
        }
        const r = t instanceof Qu ? t.Gn : s.Jt;
        if (!this.Dn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Dn; ) {
            t = t.Dn;
        }
        return t.Jt < this.Wn;
    }
    writeValue(t, n) {
        if (Bc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === zr) {
                    this.output(3, 7);
                } else if (t === Jr) {
                    this.output(3, 8);
                } else if (t === li) {
                    this.output(3, 9);
                } else {
                    if (t !== Au) {
                        throw Ne(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === ro) {
                    this.output(3, 10);
                } else if (t === eo) {
                    this.output(3, 11);
                } else if (Oe(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.On, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.On.St(n);
                            const i = this.On.St(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.Vn.get(l);
                            if (u) {
                                const t = this.On.St(u);
                                this.output(1, t);
                                return;
                            }
                            this.Vn.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!ea(t)) {
                        throw Ne(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[na];
                        this.On.Kn.add(n.vt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ui) {
                    this.output(3, 5);
                } else if (t === ci) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Qu) {
                    this.output(1, t.Gn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Dn;
                        this.Dn = e;
                        this.writeObjectValue(t);
                        this.Dn = n;
                    }
                }
                break;

              default:
                throw Ne(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (mi(t)) {
            const n = t[ri];
            this.output(38, [ zu(n), n.varProps, n.constProps, t[ii].ct ]);
        } else if (t instanceof Ni) {
            const {O: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Br) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Ou) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (qu(t)) {
            const n = Su(t);
            const e = ku(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.On.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (bu(t)) {
            const n = t[Jc](t);
            if (As(n)) {
                const t = this.resolvePromise(n, (t, n) => new Lu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Dn.Jt;
                this.Dn = this.Dn.Dn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Bc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.On.Zn(t)) {
            this.On.te(t.ne, 16);
            this.output(11, t.ne.id);
        } else if (t instanceof Gr) {
            if (t instanceof bi) {
                const n = function e(t, n) {
                    if (n === zr) {
                        return n;
                    }
                    return Ns(t.en.resolved || t.en.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Jc in n && (e = n[Jc](n));
                        e === void 0 && (e = zr);
                        return e;
                    });
                }(t, t.Zt);
                if (As(n)) {
                    const e = this.resolvePromise(n, (n, e) => new Lu(34, n, e, t.ct, t.en));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.en, t.ct, n ]);
                }
                return;
            }
            if (t instanceof Ii) {
                this.output(31, [ ...Fn(this.On, t), t.h, t.m, ...t.ct || [] ]);
            } else if (t instanceof Kr) {
                let n = t.Zt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Bc(t.Zt);
                const i = t instanceof ti;
                const c = i && t.Pt !== 0 ? t.Pt : void 0;
                const l = i && t.yn !== 1 ? t.yn : void 0;
                const u = i && t.wn !== 0 ? t.wn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = zr : e ? n = t.Zt : s && (n = zr);
                const a = [ t.en, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.pn);
                    a.push(f || void 0);
                }
                n === zr && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? Au : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Zt;
                const e = [ n === void 0 ? Au : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.On.ee(t)) {
            const n = this.On.St(t);
            this.On.se(t, ys, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Fu(e, t => {
                    this.On.St(t);
                });
                this.On.te(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.On.te(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (ji(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof fu) {
            const n = [ t.bt, t.h, t.Jt, t.ft ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (As(t)) {
            const n = this.resolvePromise(t, (t, n) => new Lu(24, t, n));
            this.output(2, n);
        } else if (t instanceof Lu) {
            if (t.re === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ct, t.ie ]);
                } else {
                    if (!t.oe) {
                        console.error(t.ie);
                        throw Ne(33);
                    }
                    {
                        const n = this.Dn.Jt;
                        this.Dn = this.Dn.Dn;
                        this.writeValue(t.ie, n);
                    }
                }
            } else {
                this.output(24, [ t.oe, t.ie ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof Uu) {
            const n = t.le;
            if (this.getSeenRefOrOutput(n, this.Dn.Jt, !0)) {
                let t = this.Xn.get(n);
                if (t === void 0) {
                    t = this.Ln++;
                    this.Xn.set(n, t);
                    this.Rt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.Un && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Un && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Un && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!Ko(t)) {
                throw Ne(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Ln++;
        t.then(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!0, s));
        }).catch(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!1, s));
        });
        this.Fn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.On.ue + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {Yn: n} = this.On;
        for (;this.jn < n.length || this.Fn.size; ) {
            let e = t > 0;
            for (;this.jn < n.length; this.jn++) {
                e ? this.Nt.write(Sr) : e = !0;
                this.writeValue(n[this.jn], this.jn);
                t++;
            }
            if (this.Fn.size) {
                try {
                    await Promise.race(this.Fn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Fn.size; ) {
            if (e < t.length) {
                n ? this.Nt.write(Sr) : n = !0;
                const s = t[e++];
                this.writeValue(this.On.Yn[s], s);
                continue;
            }
            try {
                await Promise.race(this.Fn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Rt.length - 1;
        for (;t >= 0 && this.Rt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Rt.length - 1 ? this.Rt : this.Rt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Nt.write(_r);
                this.writeRootRefPath(t);
                this.Nt.write(_r);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Nt.write(gr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.On.ce = this.On.Yn.length;
        this.On.fe = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Nt.write(Sr);
            this.Nt.write(14 + Sr);
            this.outputForwardRefsArray(n);
        }
        this.Nt.write(Er);
        this.On.ae = this.On.Yn.length + (this.On.fe ? 1 : 0);
        this.On.zn = e;
    }
}

class Lu {
    re;
    oe;
    ie;
    ct;
    bt;
    constructor(t, n, e, s, o) {
        this.re = t;
        this.oe = n;
        this.ie = e;
        this.ct = s;
        this.bt = o;
    }
}

const Fu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Xu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === ys || t === ws && (br(s) || Du(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Xu = t => typeof t === "object" && t !== null && !br(t);

const Du = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, We)) {
        return !1;
    }
    const s = n[ri];
    return br(s.varProps) && !Vu(n) && !Wu(t[ts]);
};

const Vu = t => !!t[ii].ct?.size;

const Wu = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class Uu {
    le;
    constructor(t) {
        this.le = t;
    }
}

const zu = t => new Uu(t);

let Bu = () => !1;

class Qu {
    Gn;
    constructor(t) {
        this.Gn = t;
    }
}

class Hu {
    NodeConstructor;
    DomRefConstructor;
    Et;
    se;
    dt;
    Nt;
    he=new Map;
    de=new Map;
    pe=0;
    $e=[];
    Yn=[];
    ye=[];
    me;
    ue=0;
    ae=0;
    zn=0;
    ce=0;
    fe=!1;
    Tt=new Set;
    At=new Set;
    xt=new Set;
    Kn=new Set;
    we;
    te=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Et = e;
        this.se = s;
        this.dt = o;
        this.Nt = r;
        this.we = new ju(this);
    }
    async It() {
        await this.we.serialize();
    }
    async be(t, n, e, s) {
        await this.we.serializePatch(t, n, e, s);
    }
    Bn(t) {
        this.Nt = t;
        this.we.Bn(t);
    }
    getSeenRef(t) {
        return this.he.get(t);
    }
    Hn(t, n, e) {
        const s = {
            Jt: e,
            Dn: n
        };
        this.he.set(t, s);
        return s;
    }
    ve(t) {
        const n = [];
        for (;t.Dn; ) {
            n.unshift(t.Jt);
            t = t.Dn;
        }
        n.unshift(t.Jt);
        return n;
    }
    Jn(t, n, e) {
        const s = this.ve(t);
        const o = e === void 0;
        e === void 0 && (e = this.Yn.length);
        this.Yn[e] = new Qu(s);
        o && (this.ye[e] = n);
        t.Dn = null;
        t.Jt = e;
        o && this.me?.(e, this.Yn[e], n);
    }
    St(t, n = !1) {
        let e = this.he.get(t);
        let s;
        if (e) {
            e.Dn && this.Jn(e, t);
            s = e.Jt;
        } else {
            s = this.Yn.length;
            e = {
                Jt: s
            };
            this.he.set(t, e);
            this.Yn.push(t);
            this.ye.push(t);
            this.me?.(s, t, t);
        }
        return n ? e : s;
    }
    Qn(t) {
        const n = this.Yn.length;
        const e = {
            Jt: n
        };
        this.he.set(t, e);
        this.Yn.push(t);
        this.ye.push(t);
        this.me?.(n, t, t);
        return e;
    }
    _e(t, n) {
        const e = this.Yn.length;
        const s = {
            Jt: e
        };
        this.he.set(n, s);
        this.Yn.push(t);
        this.ye.push(n);
        return e;
    }
    ee(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Zn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ge(t) {
        const n = this.he.get(t);
        return n && (n.Dn ? void 0 : n.Jt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.de.get(t);
        if (o === void 0) {
            o = this.pe + this.$e.length;
            this.de.set(t, o);
            if (s) {
                this.$e.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.$e.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ee(t, n) {
        this.pe = t;
        if (n) {
            this.de.clear();
            for (let t = 0; t < n.length; t++) {
                this.de.set(n[t], t);
            }
        }
    }
}

const Ju = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(vr(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Bu = n ? t => t instanceof n : () => !1;
    return new Hu(t, n, e, s, o, r);
};

const Yu = (t, n) => t[n];

const Gu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        qu(t) && (t = ku(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Gu(bf(Yu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Gu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (au(t)) {
            return !0;
        }
        if (mi(t)) {
            return !0;
        }
        if (As(t)) {
            return !0;
        }
        if (ji(t)) {
            return !0;
        }
        if (bu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ni) {
            return !0;
        }
        if (Bu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Oe(t) || ea(t) || t === ro || t === eo) {
            return !0;
        }
    } else if (t === li || t === zr || t === Jr) {
        return !0;
    }
    return !1;
};

const Ku = (t, n) => {
    let e = Ko(t) ? En.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Me(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Zu = !1;

const tc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Zu = !0);
            const n = `{${Me(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Ku(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = ec(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${tc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${nc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Zu ? "" : `(${JSON.stringify(t).length} chars)`;
        Zu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const nc = t => Cu[t] || `Unknown(${t})`;

const ec = t => Nu[t] || `Unknown(${t})`;

function Xn(t, n, e, s = 0) {
    const o = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const r = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let e = s; e < t.length; e += 2) {
        o(t[e], t[e + 1]) ? i(e) : r(t[e]) && (n.Rt = t[e + 1]);
    }
}

const sc = new WeakMap;

const rc = new Map;

const ic = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Ct(e);
        return s === -1 || s === void 0 ? li : t._(s);

      case 14:
        return e;

      case 3:
        return Iu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t._(i);
                const f = t._(l);
                n = jn(u, f, r !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new fu(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return ta(null);

      case 30:
        return new Gr(t, 0);

      case 31:
        return new Ii(t, null, null, null);

      case 32:
        return new Kr(t, null);

      case 33:
        return new ti(t, null, void 0, {});

      case 34:
        return new bi(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = ic(t, s, o);
            const i = Mu(r, 0, t);
            jc(s) && rc.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Ci(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        sc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return Dn(t, e);

      case 11:
        const h = Dn(t, e);
        if (Ko(h)) {
            Cl(h);
            return nu(h);
        }
        throw Ne(17, [ typeof h ]);

      case 39:
        return new Ni({});

      case 42:
        return new Ni({
            O: null,
            et: !0
        });

      case 43:
        return new Ni({
            O: null,
            et: !1
        });

      case 40:
      case 44:
        return new Br(null, null, null, null);

      case 41:
        return new Ou;

      default:
        throw Ne(18, [ n ]);
    }
};

function Dn(t, n) {
    return n ? t.rootVNode ? dl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const oc = (t, n, e) => {
    let s = null;
    let o = null;
    if (Ie(t)) {
        o = t;
    } else {
        if (!Ae(t)) {
            throw Ne(7, [ t ]);
        }
        s = t;
    }
    return Vf(s, n, null, o, e);
};

const lc = (t, n, e) => Vf(null, n, t, null, e);

const uc = (t, n) => Vf(null, t, null, null, n);

const cc = (t, n, e) => {
    const s = uc(t, e);
    return s;
};

const fc = (t, n, e, s) => Vf(t, e, null, n, s);

const ac = (t, n, e, s, o) => {
    const r = fc(t, n, e, o);
    r.Se(s);
    return r;
};

const hc = (t, n, e, s) => {
    const o = oc(t, n, s);
    return o;
};

const dc = (t, n, e, s) => {
    const o = lc(t, n, s);
    return o;
};

const pc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const $c = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const yc = (t, n, e) => new Ii(null, t, n, e || null);

class mc {
    ke;
    dt;
    Re=null;
    Cn=!1;
    jt;
    _;
    Dt;
    Pe=0;
    Te=null;
    qe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Dt = t;
        this.jt = n;
        this.ke = kr;
        this.dt = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return gf(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return Ju(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const wc = Symbol();

const Hh = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[wc] = t;
    return n;
};

class bc {}

function Wn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Un(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === bc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        As(n) && await n;
                    }
                    continue;
                }
                zn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                As(n) && await n;
            }
        }
    })();
}

function zn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (du(e)) {
            (function s(t, n) {
                const e = n instanceof Ii ? n.rt() : n;
                if (e instanceof ti) {
                    const n = e.Pt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(ci);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Ii ? e.rt() : e;
            n(t.closeFragment);
            n(() => gf(r, o, ".", t));
            n(bc);
        } else if (As(e)) {
            t.openFragment(ci);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Un(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = di(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (Ie(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && wc in t)(r)) {
                    n(() => (t => t[wc])(r)(t, o, s, n));
                    return;
                }
                if (r === eo) {
                    const e = o.key != null ? {
                        [ms]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === ro) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = di(o, cs);
                        c && (i[cs] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[Be] = f;
                        n(Wn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Wn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ci;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === lo) {
                    t.commentNode(di(o, "data") || "");
                } else if (r === co) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Ie(e) ? e({
                        async write(n) {
                            await Un(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    As(r) && n(Promise);
                } else if (r === oo) {
                    t.htmlNode(di(o, "data"));
                } else if (r === uo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (ea(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[na];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(We, o);
                        s.setProp(ws, r);
                        n.key !== null && s.setProp(ms, n.key);
                        return Oo(t, s, s, o, r);
                    })(t, o, r);
                    n(Wn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (As(l)) {
                        n(async () => {
                            const t = await l;
                            const e = Ls(i.getProp(Ke));
                            n(t);
                            n(Wn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = Ls(i.getProp(Ke));
                        n(Wn(s, t, c));
                    }
                } else {
                    const e = {
                        [ms]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Oo(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    As(i) && n(Promise);
                }
            }
        }
    }
}

const vc = () => Of;

const _c = async t => {
    const [n, e] = Of;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = An(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const gc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ro();
    if (e) {
        return e;
    }
    const r = Vf(null, "_rsc", _c, null, [ t, {} ], o.$);
    const i = _i(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Ec = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (As(t)) {
        return t.then(n, s);
    }
    const o = Sc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return As(i) ? i.then(n, s) : n(i);
};

const Sc = t => t && t.__brand === "resource";

function Bn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.vt.startsWith("_") || !Array.isArray(n.Mt) && !s || (n = Vf(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Oe(o)) {
                i(c(o));
                Qn(t, n, o);
            } else if (o != null) {
                const e = Bn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Oe(r)) {
        o = c(r);
        Qn(t, n, r);
    }
    return o;
}

function Qn(t, n, e) {
    const s = Vs(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.xt.add(r);
        t.At.add(e);
    }
}

const kc = (t, n, e) => {
    Tc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Rc = (t, n, e) => {
    Tc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Pc = (t, n, e) => {
    Tc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Tc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = qc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Ds(i), e, s);
            }
        } else {
            r(t + Ds(n), e, s);
        }
    }
};

const qc = () => {
    const t = mf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Ss);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Ss, s);
    }
    let o = t.$.getHostProp(e, ks);
    o === null && (o = 0);
    t.$.setHostProp(e, ks, o + 1);
    let r = t.$.getHostProp(e, Rs);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Rs, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Mc = function(t, n) {
    const e = ue(n);
    typeof this === "string" && jf(Lf(e, this));
    const s = Of?.[1];
    const o = s ?? n.getAttribute("data-qwik-inspector");
    if (!o || !t.detail.files.some(t => o.startsWith(t))) {
        return;
    }
    const r = Of?.[0];
    if (!r || r.flags & 32) {
        return;
    }
    yn(e, r, 4);
    const i = n.ownerDocument;
    i.__hmrDone = i.__hmrT;
};

let xc;

function Hn(t) {
    const n = $f();
    if (!n) {
        return;
    }
    xc ||= lc(Mc, "_hmr");
    const e = n.m;
    const s = xc.w([ e, t ]);
    Rc("qHmr", s);
}

function Jn(t, n, e, s, o) {
    const r = Go();
    ol(r, Be, o);
    r.parent = n;
    ol(n, o, r);
    ol(r, We, e);
    ol(r, ws, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function Yn(t, n) {
    ol(t, Ue, n);
    t.flags |= 2048;
}

function Gn(t, n, e) {
    ol(n, ws, e);
    yn(t, n, 4);
}

function Kn(t, n, e, s) {
    ol(n, s, null);
    const o = [];
    Et(t, o, e);
    bl(o);
    if (e.flags & 2048) {
        const t = il(e, Ue, null);
        t && t.replaceChildren();
        ol(e, Ue, null);
        e.flags &= -2049;
    }
}

let Ac = Promise.resolve();

const Ic = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Nc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Ic.has(t));
};

const Cc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = Oc(t, s));
    switch (e) {
      case 4:
        Oc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Nc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Jt = r[2];
        o.ft = r[3];
        break;

      case 29:
        n[na][0] = s[0];
        break;

      case 35:
        {
            const e = Tu(n);
            const o = rc.get(e);
            if (o) {
                rc.delete(e);
                Cc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Su(n);
            c.h = r;
            c.ct = i;
            ee(c.ct, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            t.ct = new Set(e.slice(1));
            ne(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Zt = zr;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Ko(t.m)) {
                    const n = t.m;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Ae(e)) {
                                const o = il(n, e, null);
                                if (o !== null) {
                                    t.Zt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Nl(n);
                        e && n.firstChild === n.lastChild && el(e) && (t.Zt = Al(e));
                    }
                }
            })(e);
            ne(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.en = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.pn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.dn = !0);
            const o = e.length > 6;
            o && (t.Zt = e[6]);
            t.Zt === zr && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.yn = e[8] ?? 1;
                t.mn = [];
            }
            t.wn = e[9] ?? 0;
            ne(t.ct, t);
            ne(t.$t, t);
            ne(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.en = r[0];
            const i = o.en.resolve(t).catch(() => {});
            Ac = Ac.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Zt = r[2]);
            e !== 34 && o.Zt !== zr && (o.h &= -2);
            ne(o.ct, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = sc.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === li) {
            a = new Ci(eo, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[ri] = a;
        const h = u[ii];
        h.ct = f[3];
        ee(h.ct, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            te(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            te(t);
            break;
        }

      default:
        throw Ne(16, [ e ]);
    }
};

const Oc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Zn(t, n[s], n[s + 1]);
    }
    return e;
};

function Zn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = ic(t, n, e);
    jc(n) && Cc(t, s, n, e);
    return s;
}

function te(t) {
    const n = ve;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Pr] ||= new Map;
    e[Pr].set(t.property, t);
}

function ne(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function ee(t, n) {
    if (t) {
        for (const [, e] of t) {
            ne(e, n);
        }
    }
}

const jc = t => t >= 23 || t === 4 || t === 5;

const Lc = new WeakMap;

const Fc = Symbol();

const Xc = (t, n) => {
    if (!Array.isArray(n) || Ko(n) || (t => Me(t) && Fc in t)(n)) {
        return n;
    }
    let e = Lc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new Dc(t, n));
        Lc.set(n, e);
    }
    return e;
};

class Dc {
    $;
    Me;
    constructor(t, n) {
        this.$ = t;
        this.Me = n;
    }
    get(t, n, e) {
        if (n === Fc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Me.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Me[o];
        const i = this.Me[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = ic(c, r, i);
        Reflect.set(t, n, l);
        this.Me[o] = 0;
        this.Me[o + 1] = l;
        jc(r) && Cc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Fc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Fc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Me.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Me[i] = 0;
        this.Me[i + 1] = e;
        return !0;
    }
}

async function se(t) {
    const n = Ju(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.It();
    return n.Nt.toString();
}

function re(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = oe(n);
    return Zn(e, n[0], n[1]);
}

function ie(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function oe(t) {
    let n;
    const e = {
        _: t => ie(t, n),
        Ct: t => e.Rt?.[+t],
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        Rt: null
    };
    Xn(t, e);
    n = Xc(e, t);
    e.Ot = n;
    return e;
}

const Vc = (t, n) => {
    const e = new WeakSet;
    return bf(Wc, t, e, "_", n);
};

const Wc = (t, n, e, s) => {
    const o = Tu(t);
    if (o == null) {
        return t;
    }
    if (zc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (du(o)) {
            return t;
        }
        if (Gu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (As(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (xe(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ne(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Ne(3, [ o ]);
                    }
                    Wc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Ir) {
                return t;
            }
            if (qe(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Wc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ne(3, [ i ]);
    }
    return t;
};

const Uc = /*#__PURE__*/ new WeakSet;

const zc = t => {
    if (Me(t) || Ie(t)) {
        return !Uc.has(t) && !(Hc in t);
    }
    return !0;
};

const Bc = t => !!t && (Me(t) || typeof t === "function") && (Uc.has(t) || Hc in t);

const Qc = t => {
    (Me(t) && t !== null || typeof t === "function") && Uc.add(t);
    return t;
};

const Hc = Symbol();

const Jc = Symbol();

const Yc = t => /*#__PURE__*/ Object.freeze({
    id: Ds(t)
});

const Gc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ro();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Kc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ro();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(pe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ne(8, [ t.id ]);
};

const Zc = t => {
    const n = yf();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const tf = /*#__PURE__*/ Yc("qk-error");

const Jh = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Yh = new WeakMap;

class Gh {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Kh(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Jh(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Kh = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Zh = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = $f()?.$;
    return t?.outOfOrderStreaming === !0 && !Bh(t);
};

const nf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && wu(t, n, r);
};

const ef = new WeakMap;

const sf = (t, n) => {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`${of(e.Te)}${He}`);
    const o = rf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(Dh) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        lf(t, e, i.textContent);
    }
};

const rf = t => {
    let n = ef.get(t);
    if (!n) {
        n = new WeakSet;
        ef.set(t, n);
    }
    return n;
};

const of = t => `script[type="qwik/state"][q\\:instance="${t}"]`;

const lf = (t, n, e) => {
    if (e) {
        const [s, o, r, i] = JSON.parse(e);
        uf(t, n, s, o);
        cf(n, r || void 0);
        ((t, n) => {
            if (!__EXPERIMENTAL__.suspense || !n) {
                return;
            }
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                const o = t._(s.rootId);
                const r = s.subscriptions;
                if (o instanceof Gr) {
                    r instanceof Set && nf(t, o, o, o.ct ||= new Set, r);
                } else {
                    if (!(r instanceof Map)) {
                        continue;
                    }
                    const n = Su(o);
                    const e = ku(o);
                    if (!n || !e) {
                        continue;
                    }
                    const s = n.ct ||= new Map;
                    for (const [o, i] of r) {
                        let r = s.get(o);
                        if (!r) {
                            r = new Set;
                            s.set(o, r);
                        }
                        nf(t, n, e, r, i);
                    }
                }
            }
        })(t, i === void 0 ? void 0 : n._(i));
    }
};

const uf = (t, n, e, s) => {
    const o = n.xe.length / 2;
    if (e !== o) {
        return;
    }
    for (let t = 0; t < s.length; t++) {
        n.xe[e * 2 + t] = s[t];
    }
    Xn(n.xe, t, 0, e * 2);
    n.Ae = Xc(t, n.xe);
    n.Ae.length = n.xe.length / 2;
    n.Ie = n.Rt;
};

const cf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Ie ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Rt = e;
};

function le(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = t => {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && w(s);
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = (n, e, s, o, r, i, c, l) => {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;ff(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && v(t.createTreeWalker(e, 129), null, e, null, "", null, null);
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = af(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? Ve(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== De || n.charCodeAt(1) !== De || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
        } while (s = S || n.nextNode());
    };
    const g = (n, e, s, o) => {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = __EXPERIMENTAL__.suspense ? (t, n, e, s) => {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && g(t, n, s, e);
    } : null;
    h.qProcessVNodeDataPatch = t => {
        const n = t?.closest("[q\\:container]");
        const e = t?.getAttribute("q:r");
        const s = n && (e ? n.querySelector(`[q\\:rp="${e}"]`) : n);
        n && s && g(n, s, t.textContent, e || void 0);
    };
    if (__EXPERIMENTAL__.suspense && n !== void 0) {
        if (e && s && o) {
            e.qVNodeRefs ||= new Map;
            E(e, s, n, o);
        }
        return;
    }
    w(t);
    const S = t.createTreeWalker(t, 129);
    v(S, null, S.firstChild(), null, "", null, null);
}

const ff = t => 33 <= t && t <= 46;

const af = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && ff(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ue(t) {
    const n = fe(t);
    if (!n) {
        throw Ne(24);
    }
    return ce(n);
}

function ce(t) {
    const n = t;
    return n.qContainer ||= new hf(n);
}

function fe(t) {
    return t.closest(as);
}

function ae(t, n) {
    const e = t + "";
    const s = n?.closest(as);
    const o = s?.qContainer;
    if (o) {
        (function t(n, e, s) {
            if (!__EXPERIMENTAL__.suspense || !s) {
                return;
            }
            const o = s.closest("[q\\:container]");
            const r = o?.querySelector(`script[type="qwik/vnode"][q\\:r="${e}"]:not([q\\:patch])`);
            le(n, e, o, s, r?.textContent || void 0);
            const i = o?.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${e}"][q\\:patch]`);
            for (let t = 0; i && t < i.length; t++) {
                n.qProcessVNodeDataPatch?.(i[t]);
            }
        })(o.element.ownerDocument, e, n);
        sf(o, e);
    }
}

class hf extends mc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    Ne;
    Te;
    Rt=null;
    vNodeLocate=t => dl(this.rootVNode, t);
    xe;
    Ae;
    Ie=null;
    Ce=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(ls);
        if (!this.qContainer) {
            throw Ne(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.qe = t.getAttribute(es);
        this.Te = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Jo(this.element);
        this.xe = [];
        this.Ae = [];
        const n = this.element.ownerDocument;
        n.qVNodeDataProcessed || function e(t) {
            le(t);
            t.qVNodeDataProcessed = !0;
        }(n);
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= ae);
        this.Ne = ns(n, this.Te) || ui;
        this.Oe();
        t.setAttribute(ls, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.Tn();
        this.je();
        __EXPERIMENTAL__.suspense && sf(this);
        this.Le();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Tn() {
        this.vNodeLocate = () => null;
        this.xe.length = 0;
        this.Ae.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(ls);
        const n = t.ownerDocument;
        const e = n.querySelector(as) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    je() {
        const t = this.element.querySelector(`${this.Fe()}:not(${He})`);
        if (t) {
            this.xe = JSON.parse(t.textContent);
            Xn(this.xe, this);
            this.Ie = this.Rt;
            this.Ae = Xc(this, this.xe);
        }
    }
    Fe() {
        return `script[type="qwik/state"][q\\:instance="${this.Te}"]`;
    }
    Le() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ge);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    An(t, n) {
        this.Ae[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, tf);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Ze);
        s == null && this.setHostProp(t, Ze, s = []);
        Re(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Ze);
            if (e != null && Te(e, n.id, 0)) {
                return Pe(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (sl(n)) {
                if (il(n, We, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        ol(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case bs:
          case ws:
          case We:
          case Ze:
          case ts:
          case cs:
            s = this._;
            break;

          case vs:
          case ks:
            s = parseInt;
            break;
        }
        return il(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => ie(t, this.Ae);
    Ct(t) {
        return this.Ie?.[t];
    }
    getSyncFn(t) {
        const n = this.Ne[t];
        return n;
    }
    Xe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ke);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ke, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ce == null) {
            this.Ce = new Set;
            const t = this.document.querySelectorAll(Ye);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ce.add(e.getAttribute(Je));
            }
        }
        if (!this.Ce.has(n)) {
            this.Ce.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Je, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Oe() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Ts) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Dt = {
            containerAttributes: t
        };
    }
}

let df;

let td;

if (ve) {
    const t = $c();
    t && (td = new t);
}

function he(t) {
    if (td) {
        const t = td.getStore();
        if (t) {
            return t;
        }
    }
    if (df === void 0) {
        const n = $f();
        if (n && n.jt) {
            return n.jt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return df;
}

function de(t, n) {
    if (td) {
        return td.run(t, n);
    }
    const e = df;
    try {
        df = t;
        return n();
    } finally {
        df = e;
    }
}

let pf;

const $f = () => pf;

const yf = () => {
    const t = $f();
    if (!t) {
        throw Ne(9);
    }
    return t;
};

const mf = () => {
    const t = $f();
    if (!t || t.Lt !== $s) {
        throw Ne(10);
    }
    return t;
};

function pe(t, n, ...e) {
    return $e.call(this, t, n, e);
}

function $e(t, n, e) {
    const s = pf;
    try {
        pf = t;
        return n.apply(this, e);
    } finally {
        pf = s;
    }
}

const wf = (t, n) => {
    const e = ue(n);
    const s = dl(e.rootVNode, n);
    const o = e.jt;
    o && function r(t) {
        if (td) {
            td.enterWith(t);
            return;
        }
        df = t;
    }(o);
    const i = me(o, s, t);
    i.$ = e;
    return i;
};

function ye(t, n, e) {
    const s = {
        m: n,
        Lt: $s,
        Ft: void 0,
        jt: t,
        $: e,
        Xt: void 0
    };
    return s;
}

function me(t, n, e) {
    const s = t || (e && Me(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        Lt: e,
        Ft: void 0,
        jt: s,
        $: void 0
    };
    return o;
}

const bf = (t, ...n) => {
    if (typeof t === "function") {
        if (!pf) {
            return t(...n);
        }
        {
            const e = pf.Ft;
            try {
                pf.Ft = void 0;
                return t(...n);
            } finally {
                pf.Ft = e;
            }
        }
    }
    if (du(t)) {
        return t.untrackedValue;
    }
    return Tu(t);
};

const vf = /*#__PURE__*/ ye(void 0, void 0, void 0);

const _f = (t, n, e, s, o) => {
    const r = vf.Ft;
    const i = vf.$;
    try {
        vf.Ft = m(n, e, o);
        vf.$ = s;
        return $e(vf, t);
    } finally {
        vf.Ft = r;
        vf.$ = i;
    }
};

const gf = (t, n, e, s, o) => {
    t instanceof Ii && t.m !== n && n && (t.m = n);
    return _f(() => t.value, n, e, s, o);
};

const Ef = () => $f()?.m;

const Sf = () => {
    const t = $f();
    if (t) {
        return t.Lt;
    }
};

const kf = () => {
    const t = $f();
    if (t) {
        return t.$;
    }
};

const Rf = t => t;

const Pf = t => t.l || Promise.resolve();

let Tf = (t, n, e, s, o) => new qf(t, n, e, s, o);

class qf {
    _t;
    vt;
    De;
    Ve;
    $;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.vt = n;
        this.De = e;
        this.Ve = s;
        s && this.We(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        _e && t && be(t, .8);
    }
    get it() {
        return Xh(this.vt);
    }
    We(t) {
        this.Ve = t;
        As(t) && t.then(t => this.Ve = t, t => {
            console.error(`qrl ${this.vt} failed to load`, t);
            this.Ve = null;
        });
    }
    Ue() {
        if (this.Ve != null) {
            return this.Ve;
        }
        if (this._t === "") {
            const t = this.$.Te;
            const n = this.$.element?.ownerDocument || document;
            const e = ns(n, t);
            return this.Ve = e[+this.vt];
        }
        _e && this._t && be(this._t, 1);
        const t = this.vt;
        const n = this.De ? this.De().then(n => n[t]) : tr().importSymbol(this.$?.element, this._t, t);
        this.We(n);
        return this.Ve;
    }
}

_e && import.meta.hot && (t => {
    if (!_e || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Tf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.De?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.De = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.vt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.vt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.Ve = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(qf);

const Mf = Symbol();

const xf = t => t?.[Mf] ?? t;

class Af {
    ze;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ze = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.Ve == null || this.Mt && typeof this.Mt === "string" || As(t.Ve) || (this.resolved = Xf(this, t.Ve));
    }
}

const If = function(t, ...n) {
    const e = xf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = $f();
    return Nf.call(e, s?.$).then(() => $e.call(t, s, e.resolved, n));
};

const Nf = async function(t) {
    const n = xf(this);
    return Ns(Df(n, t), () => n.resolved);
};

const Cf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Mf].resolved;
        },
        set(t) {
            this[Mf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[Mf].Mt;
        },
        set(t) {
            this[Mf].Mt = t;
        }
    },
    $: {
        get() {
            return this[Mf].$;
        },
        set(t) {
            this[Mf].$ = t;
        }
    },
    ze: {
        get() {
            return this[Mf].ze;
        }
    },
    _t: {
        get() {
            return this[Mf].ze._t;
        }
    },
    vt: {
        get() {
            return this[Mf].ze.vt;
        }
    },
    it: {
        get() {
            return this[Mf].ze.it;
        }
    },
    dev: {
        get() {
            return this[Mf].ze.dev;
        }
    },
    Be: {
        value: If
    },
    w: {
        value: function(t) {
            const n = xf(this);
            const e = new Af(n.ze, t, n.Mt ? n.$ : void 0);
            return Wf(e);
        }
    },
    s: {
        value: function(t) {
            const n = xf(this);
            n.ze.We(t);
            n.resolved = Xf(n, t);
        }
    },
    resolve: {
        value: Nf
    },
    getSymbol: {
        value: function() {
            return xf(this).ze.vt;
        }
    },
    getHash: {
        value: function() {
            return xf(this).ze.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = xf(this);
            Ff(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = xf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Nf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return $e(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Of = null;

const jf = t => {
    Of = t;
};

const Lf = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t._(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const Ff = t => {
    const n = t.Mt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Ne(13);
        }
        const s = Ac;
        Of = t.Mt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Lf(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Lf(t, n, s + 1, o);
        })(e, n);
        if (Ac !== s) {
            return Ac;
        }
    } else {
        Of = n || null;
    }
};

const Xf = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        Ff(t);
        return n.apply(this, s);
    };
};

const Df = (t, n) => {
    const e = t.ze;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || $f()?.$);
    if (t.resolved) {
        return;
    }
    const o = Qf();
    const r = $f();
    const i = e.Ue();
    const c = Ns(i, n => {
        t.resolved = Xf(t, n);
    });
    if (c) {
        const t = e.vt;
        zf(t, r?.m instanceof Cr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Ff(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Vf = (t, n, e, s, o, r) => {
    const i = Tf(t, n, s, e, r);
    const c = new Af(i, o, r);
    return Wf(c);
};

const Wf = t => {
    const n = async function(...t) {
        return If.call(n, this, ...t);
    };
    n[Mf] = t;
    Object.setPrototypeOf(n, Cf);
    return n;
};

const Uf = /*#__PURE__*/ new Set;

const zf = (t, n, e) => {
    if (!Uf.has(t)) {
        Uf.add(t);
        Bf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Bf = (t, n) => {
    Vh() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Qf = () => {
    if (Vh()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Hf = 0;

const Jf = t => Vf(null, "s" + Hf++, t, null, null);

const Yf = Jf;

const Gf = t => t;

const Kf = t => Vf("", Ce, t, null, null);

const Zf = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Vf("", Ce, t, null, null);
};

const ta = t => {
    function n(n, e, s = 0) {
        const o = t.it.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[na] = [ t ];
        return Hi(i, n, null, n.children, s, r);
    }
    n[na] = [ t ];
    return n;
};

const na = Symbol();

const ea = t => typeof t == "function" && t[na] !== void 0;

const sa = t => ta(Yf(t));

const ra = wi(Gf);

const ia = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const oa = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Rr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(ls, "resumed");
    const s = ue(t);
    s.Dt = e.serverData || {};
    const o = s.rootVNode;
    ol(o, Dr, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const la = (t, n) => {
    const {val: e, set: s, iCtx: o} = Ro();
    if (e != null) {
        return e;
    }
    const r = Ie(t) ? pe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Mu(r, i, t);
        s(c);
        return c;
    }
};

const ua = () => {
    const {val: t, set: n, iCtx: e} = Ro();
    if (t != null) {
        return t;
    }
    const s = e.$.qe || "";
    const o = s ? Us(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, We);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Re;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Pe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function we(t, n) {
    const e = $f();
    return e?.$?.Dt[t] ?? n;
}

const ca = /*#__PURE__*/ new Map;

const fa = (t, n) => {
    let e = ca.get(n);
    e || ca.set(n, e = aa(t, n));
    return e;
};

const aa = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = ya;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Wa) {
            r++;
            e = Xa;
        }
        const s = Ga[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === ka || $ === Ra && ha(l) || $ === Ta && $a(l)) && (y === e || y === ka || y === Ra && ha(e) || y === Pa && !ha(e) && e !== Oa || y === Ta && $a(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === Ea || m == Sa) {
                    if (m === Sa) {
                        if (c !== ma || h()) {
                            if (!da(e)) {
                                const t = y == Pa ? 1 : y == Na ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            da(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Pa) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || ya;
                        if (c === wa) {
                            u(r - 1);
                            i++;
                        }
                    } while (pa(c));
                } else {
                    o.push(c);
                    if (c === wa && m === ya) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === ba && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === wa || h()) {
            return;
        }
        u(t);
        s.push(".", ze, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ca) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ca) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | za) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(wa) !== -1 || o.indexOf(va) !== -1;
    }
};

const ha = t => t >= ja && t <= La || t >= Xa && t <= Da || t >= Ba && t <= Qa || t >= 128 || t === Ua || t === Ca;

const da = t => t === Fa || t === Oa || t === Va || t === Ia || ha(t);

const pa = t => t === _a || t === va || t === ga || t === wa;

const $a = t => t === Aa || t === qa || t === Ma || t === xa;

const ya = 0;

const ma = 2;

const wa = 5;

const ba = 6;

const va = 10;

const _a = 11;

const ga = 12;

const Ea = 17;

const Sa = 18;

const ka = 0;

const Ra = 1;

const Pa = 2;

const Ta = 3;

const qa = 9;

const Ma = 10;

const xa = 13;

const Aa = 32;

const Ia = 35;

const Na = 41;

const Ca = 45;

const Oa = 46;

const ja = 48;

const La = 57;

const Fa = 58;

const Xa = 65;

const Da = 90;

const Va = 91;

const Wa = 92;

const Ua = 95;

const za = 32;

const Ba = 97;

const Qa = 122;

const Ha = 123;

const Ja = 125;

const Ya = /*@__PURE__*/ (() => [ [ ka, 39, 14 ], [ ka, 34, 15 ], [ ka, 47, 16, "*" ] ])();

const Ga = /*@__PURE__*/ (() => [ [ [ ka, 42, ma ], [ ka, Va, 7 ], [ ka, Fa, ba, ":", "before", "after", "first-letter", "first-line" ], [ ka, Fa, wa, "global" ], [ ka, Fa, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ ka, Fa, 4 ], [ ka, Ra, 1 ], [ ka, Oa, 1 ], [ ka, Ia, 1 ], [ ka, 64, va, "keyframe" ], [ ka, 64, _a, "media", "supports", "container" ], [ ka, 64, ga ], [ ka, Ha, 13 ], [ 47, 42, 16 ], [ ka, 59, Ea ], [ ka, Ja, Ea ], [ ka, Na, Ea ], ...Ya ], [ [ ka, Pa, Sa ] ], [ [ ka, Pa, Sa ] ], [ [ ka, 40, ya ], [ ka, Pa, Sa ] ], [ [ ka, 40, 8 ], [ ka, Pa, Sa ] ], [ [ ka, 40, ya ], [ ka, Pa, Ea ] ], [ [ ka, Pa, Ea ] ], [ [ ka, 93, Sa ], [ ka, 39, 14 ], [ ka, 34, 15 ] ], [ [ ka, Na, Ea ], ...Ya ], [ [ ka, Ja, Ea ], ...Ya ], [ [ ka, Ja, Ea ], [ Ta, Ra, 1 ], [ ka, Fa, wa, "global" ], [ ka, Ha, 13 ], ...Ya ], [ [ ka, Ha, ya ], [ ka, 59, Ea ], ...Ya ], [ [ ka, 59, Ea ], [ ka, Ha, 9 ], ...Ya ], [ [ ka, Ja, Ea ], [ ka, Ha, 13 ], [ ka, 40, 8 ], ...Ya ], [ [ ka, 39, Ea ] ], [ [ ka, 34, Ea ] ], [ [ 42, 47, Ea ] ] ])();

const Ka = t => ({
    styleId: eh(t, t => t, !1)
});

const Za = /*#__PURE__*/ wi(Ka);

const th = t => ({
    scopeId: ze + eh(t, fa, !0)
});

const nh = /*#__PURE__*/ wi(th);

const eh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Ro();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Us(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Xe(n(t, c), c, l, e));
    }
    r.$.Xe(n(t.resolved, c), c, l, e);
    return c;
};

const sh = (t, n) => {
    t.resolve();
    return vi(t, n);
};

const rh = (t, n) => qo(sh, t, n);

const ih = wi(rh);

const oh = t => {
    t.resolve();
    return gi(t);
};

const lh = t => qo(oh, t);

const uh = wi(lh);

const ch = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Ro();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Vh()) {
            e.h |= 32;
            fh(e, i);
        }
        return;
    }
    let c;
    if (Vh()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r.m, 1);
    }
    const l = new fu(c, o, r.m, t, null);
    s(l);
    fh(l, i);
};

const fh = (t, n) => {
    n === "intersection-observer" ? kc("qvisible", ah(t)) : n === "document-ready" ? Rc("qinit", ah(t)) : n === "document-idle" && Rc("qidle", ah(t));
};

const ah = t => Vf(null, "_task", Mn, null, [ t ]);

const hh = wi(gc);

const dh = /*#__PURE__*/ wi(uu);

const ph = /*#__PURE__*/ wi(ch);

const $h = (t, n) => {
    t.resolve();
    return _i(t, n);
};

const yh = (t, n) => qo($h, t, n);

const mh = wi(yh);

const wh = () => {
    const t = la({
        error: void 0
    });
    Gc(tf, t);
    return t;
};

const bh = async ({track: t}) => {
    const n = Of[0];
    t(() => n.items);
    const e = $f();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const r = ve;
    r && await o.l;
};

const vh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    uu(/*#__PURE__*/ lc(bh, "_eaT", [ t ]));
    return io;
};

const _h = /*#__PURE__*/ ta(
/*#__PURE__*/ lc(vh, "_eaC"));

const gh = (t, n, e) => Oe(t) ? t.getFn(n)(e) : t(e);

const Eh = ({track: t}) => {
    const n = Of[0];
    const e = $f();
    const s = e.m;
    const o = e.$;
    const r = ve;
    return Ns(t(() => gh(n.when$, $f(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return Ns(i ? gh(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Sh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    uu(/*#__PURE__*/ lc(Eh, "_shT", [ t ]));
    return io;
};

const kh = /*#__PURE__*/ ta(
/*#__PURE__*/ lc(Sh, "_shC"));

const Rh = /*#__PURE__*/ Yc("qk-reveal");

const Ph = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ei(0)
});

const Th = () => {
    const t = Of[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!_e) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Jh(t);
};

const qh = ({cleanup: t}) => {
    const n = Of[0];
    t(() => {
        if (!_e) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Mh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = qo(Ph, t);
    Gc(Rh, n);
    const e = !_e;
    if (__EXPERIMENTAL__.suspense && e && Zh()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!Zh()) {
                    return null;
                }
                const e = $f()?.$;
                let s = 0;
                if (e) {
                    s = (Yh.get(e) || 0) + 1;
                    Yh.set(e, s);
                }
                return new Gh(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Qc(e);
            return e;
        })(n);
        /*#__PURE__*/
        return Qi(nd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return Qi(ro, null, null, null, 0, "u7_0");
};

const xh = /*#__PURE__*/ ta(
/*#__PURE__*/ lc(Mh, "_reC"));

const nd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Hh((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Qi(ro, null, null, null, 0, "u7_0"));
}) : null;

const Ah = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const ed = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Ih = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Nh = ({track: t, cleanup: n}) => {
    const e = Of[0], s = Of[1], o = Of[2], r = Of[3];
    const i = t(e.pending);
    const c = _e;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Ch = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = To("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return qo(Mo);
    })();
    const s = (t => {
        const n = Kc(Rh, null);
        const e = qo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && uu(/*#__PURE__*/ lc(qh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = rh(
    /*#__PURE__*/ lc(Th, "_reR", [ s ]));
    uu(
    /*#__PURE__*/ lc(Nh, "_suT", [ e, t, n, s ]));
    const r = !_e;
    const i = r && Zh();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = $f()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && rd(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ yc(Ah, [ t, n, o, s ], ed) : null;
    const d = /*#__PURE__*/ yc(Ih, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ Qi(sd, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, Mi(t, "fallback"), 1, null) : /*#__PURE__*/ Qi("div", {
        style: yc(Ah, [ t, n, o, s ], ed)
    }, null, Mi(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ Qi("div", null, i ? {
        [Wh]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ Qi(i ? od : ro, i ? {
        [cs]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [cs]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Oh = /*#__PURE__*/ ta(
/*#__PURE__*/ lc(Ch, "_suC"));

const sd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Hh((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !rd(r) ? l.value = "fallback" : o && c && rd(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ Qi("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const od = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Hh(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return Qi(ro, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return Qi(ro, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${Dh}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${Dh}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function rd(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const jh = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Lh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Qi("script", null, o, null, 0, "prefetch-service-worker");
};

const Lh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Fh = () => null;

globalThis.__qwik && Ne(30, [ globalThis.__qwik, kr ]);

globalThis.__qwik = kr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Jf as $, _h as Each, eo as Fragment, Hc as NoSerializeSymbol, Fh as PrefetchGraph, jh as PrefetchServiceWorker, so as RenderOnce, Ec as Resource, xh as Reveal, lo as SSRComment, oo as SSRRaw, co as SSRStream, uo as SSRStreamBlock, Jc as SerializerSymbol, kh as Show, io as SkipRender, ro as Slot, Oh as Suspense, ei as _CONST_PROPS, hf as _DomContainer, Pr as _EFFECT_BACK_REF, bs as _ELEMENT_SEQ, ui as _EMPTY_ARRAY, ci as _EMPTY_OBJ, oi as _IMMUTABLE, mc as _SharedContainer, Ni as _SubscriptionData, Ou as _SubscriptionPatch, fu as _Task, li as _UNINITIALIZED, si as _VAR_PROPS, Jn as _addProjection, Of as _captures, v as _chk, oe as _createDeserializeContainer, Vf as _createQRL, An as _createStore, Cs as _delay, re as _deserialize, tc as _dumpState, vh as _eaC, bh as _eaT, pn as _executeSsrChores, yc as _fnSignal, $c as _getAsyncLocalStorage, yi as _getConstProps, kf as _getContextContainer, Sf as _getContextEvent, Ef as _getContextHostElement, ue as _getDomContainer, fe as _getQContainerElement, m as _getSubscriber, $i as _getVarProps, Pu as _hasStoreEffects, Mc as _hmr, ni as _injectAsyncSignalValue, pe as _invoke, ji as _isJSXNode, qu as _isStore, Vn as _isStringifiable, au as _isTask, Rf as _jsxBranch, Ji as _jsxC, Gi as _jsxQ, Yi as _jsxS, Qi as _jsxSorted, Hi as _jsxSplit, ke as _mapApp_findIndx, Pe as _mapArray_get, Re as _mapArray_set, _u as _markSignalAsExternallyOwned, me as _newInvokeContext, uc as _noopQrl, cc as _noopQrlDEV, Xn as _preprocessState, Zf as _qrlSync, On as _qrlToString, fc as _qrlWithChunk, ac as _qrlWithChunkDEV, Mh as _reC, Th as _reR, qh as _reT, pc as _regSymbol, Kn as _removeProjection, _ as _res, Zc as _resolveContextWithoutSequentialScope, $o as _restProps, n as _retryOnPromise, _c as _rsc, I as _run, se as _serialize, Bn as _setEvent, Yn as _setProjectionTarget, Sh as _shC, Eh as _shT, Ch as _suC, Nh as _suT, Mn as _task, Gn as _updateProjectionProps, Hn as _useHmr, b as _val, Vc as _verifySerializable, cl as _vnode_ensureElementInflated, Kl as _vnode_getAttrKeys, xl as _vnode_getElementName, Nl as _vnode_getFirstChild, il as _vnode_getProp, yl as _vnode_getVNodeForChildNode, Rl as _vnode_insertBefore, Zo as _vnode_isElementVNode, nl as _vnode_isMaterialized, el as _vnode_isTextVNode, sl as _vnode_isVirtualVNode, Go as _vnode_newVirtual, ql as _vnode_remove, ol as _vnode_setProp, En as _vnode_toString, Pf as _waitUntilRendered, Un as _walkJSX, Mi as _wrapProp, Ai as _wrapSignal, sa as component$, ta as componentQrl, ki as createAsync$, _i as createAsyncQrl, Si as createComputed$, vi as createComputedQrl, Yc as createContextId, g as createElement, Ri as createSerializer$, gi as createSerializerQrl, Ei as createSignal, ra as event$, Gf as eventQrl, Ru as forceStoreEffects, ia as getClientManifest, ue as getDomContainer, he as getLocale, tr as getPlatform, g as h, wi as implicit$FirstArg, lc as inlinedQrl, dc as inlinedQrlDEV, ge as isDev, du as isSignal, Zi as jsx, to as jsxDEV, no as jsxs, Qc as noSerialize, oc as qrl, hc as qrlDEV, oa as render, Zs as setPlatform, Kf as sync$, bf as untrack, Tu as unwrapStore, mh as useAsync$, yh as useAsyncQrl, ih as useComputed$, rh as useComputedQrl, qo as useConstant, Kc as useContext, Gc as useContextProvider, wh as useErrorBoundary, ua as useId, vc as useLexicalScope, kc as useOn, Rc as useOnDocument, Pc as useOnWindow, hh as useResource$, gc as useResourceQrl, uh as useSerializer$, lh as useSerializerQrl, we as useServerData, To as useSignal, la as useStore, Za as useStyles$, Ka as useStylesQrl, nh as useStylesScoped$, th as useStylesScopedQrl, dh as useTask$, uu as useTaskQrl, ph as useVisibleTask$, ch as useVisibleTaskQrl, kr as version, de as withLocale };
